// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export * from './accountActivateUserDefaultResponse';
export * from './accountAddressModel';
export * from './accountAttestationAttributeModel';
export * from './accountContactModel';
export * from './accountContactPreferenceModel';
export * from './accountDocumentRelationshipModel';
export * from './accountExternalIdModel';
export * from './accountGetPrescribersDefaultResponse';
export * from './accountGetSitesDefaultResponse';
export * from './accountGetTasksDefaultResponse';
export * from './accountGetUsersDefaultResponse';
export * from './accountLinkedPayorModel';
export * from './accountModel';
export * from './accountOptionalServiceModel';
export * from './accountOrderRelationModel';
export * from './accountPayorRelationModel';
export * from './accountPhoneModel';
export * from './accountRelationModel';
export * from './accountRemovePrescriberDefaultResponse';
export * from './accountRemoveSiteDefaultResponse';
export * from './accountSavePrescriberDefaultResponse';
export * from './accountSaveSiteDefaultResponse';
export * from './accountSaveTaskDefaultResponse';
export * from './accountSaveUserDefaultResponse';
export * from './accountSaveUserRoleDefaultResponse';
export * from './accountSessionModel';
export * from './accountVoicemailOptInModel';
export * from './address';
export * from './adminGetSiteAccountsDefaultResponse';
export * from './authenticateUserRequestModel';
export * from './authenticationAuthenticateUserDefaultResponse';
export * from './authenticationChangePasswordDefaultResponse';
export * from './authenticationGetCurrentUserDefaultResponse';
export * from './authenticationIsEmailRegisteredDefaultResponse';
export * from './authenticationIsExistingUserResponse';
export * from './authenticationResetPasswordDefaultResponse';
export * from './authenticationSaveCurrentUserDefaultResponse';
export * from './authenticationTouchResponse';
export * from './authenticationTouchResponseData';
export * from './authenticationV2UserCreatePortalAdminCreatePortalAdminResponse';
export * from './authenticationV2UserCreateStandardUserCreateStandardUserResponse';
export * from './authenticationV2UserDeleteUserIdDeleteUserResponse';
export * from './authenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse';
export * from './authenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse';
export * from './authenticationV2UserUpdateUserIdUpdateUserResponse';
export * from './cancelWorkflowRequestModel';
export * from './cardAccumulatorModel';
export * from './cardClaimAccumulatorModel';
export * from './cardClaimModel';
export * from './cardInternalStatusResultModel';
export * from './cardMedicationModel';
export * from './cardMemberNumberStatusResultModel';
export * from './cardMemberNumberStatusResultModelResponse';
export * from './cardRedemptionListResultModel';
export * from './cardTcsRedemptionListRecordModel';
export * from './caseAddressModel';
export * from './caseAllowedCaseStatusModel';
export * from './caseAllowedCaseStatusModels';
export * from './caseAttestationAttributeModel';
export * from './caseConditionRelationshipModel';
export * from './caseContactPreferenceModel';
export * from './caseDocumentRelationshipModel';
export * from './caseExternalIdModel';
export * from './caseHomeHealthAgencyRelationshipModel';
export * from './caseModel';
export * from './caseOrderedRelationshipModel';
export * from './casePayorRelationshipModel';
export * from './casePhoneModel';
export * from './casePrescriptionRelationshipModel';
export * from './caseProgramCaseTypeModel';
export * from './caseProgramCaseTypeModels';
export * from './caseRelationshipModel';
export * from './caseSessionModel';
export * from './caseTypeModel';
export * from './caseTypeModels';
export * from './caseTypeStatusModel';
export * from './caseTypeStatusModels';
export * from './caseWorkflowCaseModel';
export * from './caseWorkflowModel';
export * from './changePasswordRequestModel';
export * from './claimAccumulatorModel';
export * from './claimAccumulatorModels';
export * from './claimAdjudicationClaimLineItem';
export * from './claimAdjudicationCodeModel';
export * from './claimAdjudicationMedicalInsurance';
export * from './claimAdjudicationPatientDetails';
export * from './claimAdjudicationPharmacyInsurance';
export * from './claimAdjudicationProviderDetails';
export * from './claimAdjudicationRequest';
export * from './claimAdjudicationResponse';
export * from './claimAdjudicationResponseLineItem';
export * from './claimConditionModel';
export * from './claimDetailsResponseModel';
export * from './claimExternalReferenceModel';
export * from './claimFileOutputModel';
export * from './claimKeyValuePairLongString';
export * from './claimLookupModel';
export * from './claimMedicalClaimModel';
export * from './claimMedicalClaimSearchModel';
export * from './claimPayorModel';
export * from './claimPharmacyClaimModel';
export * from './claimProviderLocationModel';
export * from './claimProviderModel';
export * from './claimSearchModel';
export * from './claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest';
export * from './claimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse';
export * from './claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest';
export * from './claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse';
export * from './contact';
export * from './couponDocumentsSubmitDocumentsSubmitDocumentsRequest';
export * from './couponDocumentsSubmitDocumentsSubmitDocumentsResponse';
export * from './couponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse';
export * from './couponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse';
export * from './couponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse';
export * from './couponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse';
export * from './couponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse';
export * from './couponGetEnrollmentDetailsDefaultResponse';
export * from './couponGetEnrollmentDetailsDefaultResponseData';
export * from './couponMemberMemberNumberStatusMemberNumberStatusRequest';
export * from './couponMemberMemberNumberStatusMemberNumberStatusResponse';
export * from './couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest';
export * from './couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse';
export * from './couponMemberReplaceCardReplaceCardRequest';
export * from './couponMemberReplaceCardReplaceCardResponse';
export * from './couponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse';
export * from './couponPatientPatientSearchPatientSearchResponse';
export * from './couponRedemptionListListResponse';
export * from './couponSubmitDocumentsRequestModel';
export * from './deactivateEnrollmentRequest';
export * from './debitCardGetDebitCardDetailDefaultResponse';
export * from './debitCardGetLashPatientDebitCardLast4DefaultResponse';
export * from './debitCardInfoResponseModel';
export * from './diagnosisModel';
export * from './diagnosisModelResponse';
export * from './diagnosisModels';
export * from './diagnosisSearchModelResponse';
export * from './diagnosisSearchRequestModel';
export * from './diagnosisSearchResponseModel';
export * from './documentCreateModel';
export * from './documentCreateResponseModel';
export * from './documentLinkModel';
export * from './documentLongResponse';
export * from './documentModel';
export * from './documentModelResponse';
export * from './documentParentLinkModel';
export * from './documentPdfDocumentModel';
export * from './documentPdfFileModel';
export * from './documentPdfFileStyleModel';
export * from './documentsV1DocumentUploadUploadResponse';
export * from './documentsV1GeneratePdfFromHtmlSaveSaveResponse';
export * from './documentsV1GeneratePdfFromTemplateSaveSaveResponse';
export * from './documentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse';
export * from './emailEmailContact';
export * from './emailIsUnsubscribedDefaultResponse';
export * from './emailReturnResult';
export * from './emailReturnResultResponse';
export * from './emailSendDefaultResponse';
export * from './emailSendEmailSingle';
export * from './emailUnsubscribeDefaultResponse';
export * from './enrollPatientRequestModel';
export * from './enrollPatientResponse';
export * from './enrollmentAccumulatorModel';
export * from './enrollmentAlternateCardId';
export * from './enrollmentCaseDocumentRelationshipModel';
export * from './enrollmentCaseOrderedRelationshipModel';
export * from './enrollmentCasePrescriptionRelationshipModel';
export * from './enrollmentCaseRelationshipModel';
export * from './enrollmentCaseRelationshipsModel';
export * from './enrollmentCaseRoleTypeRelationshipModel';
export * from './enrollmentCheckMemberNumberDefaultResponse';
export * from './enrollmentClientIdentifiersModel';
export * from './enrollmentCommTypeUpdateRequestModel';
export * from './enrollmentConditionTypeModel';
export * from './enrollmentCreatePrescriberRequestModel';
export * from './enrollmentCreatePrescriberResultModel';
export * from './enrollmentCreatePrescriberResultModelResponse';
export * from './enrollmentCreateSiteRequestModel';
export * from './enrollmentCreateSiteResultModel';
export * from './enrollmentCreateSiteResultModelResponse';
export * from './enrollmentDeactivateResponse';
export * from './enrollmentDemographicsModel';
export * from './enrollmentDocumentModel';
export * from './enrollmentEligibilityModel';
export * from './enrollmentEnrollPatientDefaultResponse';
export * from './enrollmentGetBestEnrollmentDefaultResponse';
export * from './enrollmentGetBestEnrollmentsV2DefaultResponse';
export * from './enrollmentGuardianInfoModel';
export * from './enrollmentHistoryModel';
export * from './enrollmentHybridPatientSearchResultModel';
export * from './enrollmentInsVerRequestModel';
export * from './enrollmentInsuranceVerificationModel';
export * from './enrollmentIsValidMemberNumberModel';
export * from './enrollmentIsValidMemberNumberModelResponse';
export * from './enrollmentIsValidMemberNumberRequestModel';
export * from './enrollmentMedBenClientIdentifiersModel';
export * from './enrollmentMedBenInsuranceVerificationModel';
export * from './enrollmentMedicationModel';
export * from './enrollmentMemberNumberModel';
export * from './enrollmentModel';
export * from './enrollmentPatientLookupRequestModel';
export * from './enrollmentPatientLookupResultModel';
export * from './enrollmentPatientSearchRecordModel';
export * from './enrollmentPatientSearchResultModel';
export * from './enrollmentPatientUpdateDemographicsModel';
export * from './enrollmentPatientUpdateRequestModel';
export * from './enrollmentPhoneNumberModel';
export * from './enrollmentRequest';
export * from './enrollmentRequestModel';
export * from './enrollmentResponse';
export * from './enrollmentResponseModel';
export * from './enrollmentResultModel';
export * from './enrollmentResultModelResponse';
export * from './enrollmentServiceV2PublicModelsRulesMetaRuleResultModel';
export * from './enrollmentSurveyQuestionModel';
export * from './enrollmentUpdateRequestModel';
export * from './enrollmentV2ConditionTypeModel';
export * from './enrollmentV2EligibilityModel';
export * from './enrollmentV2EnrollmentModel';
export * from './enrollmentV2MemberNumberModel';
export * from './enrollmentV2ProcessingBenefitModel';
export * from './enrollmentV2ProcessingOutcomeModel';
export * from './enrollmentV2ProcessingResultModel';
export * from './enrollmentV2RulesAssignMemberNumberResultModel';
export * from './enrollmentV2RulesMemberNumberBucketResult';
export * from './enrollmentVerifySurveyEntryRequestModel';
export * from './enrollmentVerifySurveyEntryResultModel';
export * from './enrollmentVerifySurveyEntryResultModelResponse';
export * from './enterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountExternalIdModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountRelationModel';
export * from './enterpriseCoordinatorAccountServiceModelsAccountUpsearchModel';
export * from './enterpriseCoordinatorAccountServiceModelsVoicemailOptInModel';
export * from './enterpriseCoordinatorAccountUpsearchModelResponse';
export * from './enterpriseCoordinatorAccountUpsearchRequestModel';
export * from './enterpriseCoordinatorAccountUpsearchResponseModel';
export * from './enterpriseCoordinatorCaseDocumentRelationshipModel';
export * from './enterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel';
export * from './enterpriseCoordinatorPatientServiceModelsPatientUpsearchModel';
export * from './enterpriseCoordinatorPayorServiceModelsPayorBenefitModel';
export * from './enterpriseCoordinatorPayorServiceModelsPayorUpsearchModel';
export * from './enterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel';
export * from './enterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel';
export * from './enterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel';
export * from './enterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel';
export * from './enterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel';
export * from './enterpriseCoordinatorSharedAddressUpsearchModel';
export * from './enterpriseCoordinatorSharedContactUpsearchModel';
export * from './enterpriseCoordinatorSharedEmailAddressUpsearchModel';
export * from './enterpriseCoordinatorSharedExternalIdUpsearchModel';
export * from './enterpriseCoordinatorSharedGlobalIdUpsearchModel';
export * from './enterpriseCoordinatorSharedPhoneUpsearchModel';
export * from './enterpriseCoordinatorSharedWebAddressUpsearchModel';
export * from './enterpriseCoordinatorSiteAccountUpsearchModelResponse';
export * from './enterpriseCoordinatorSiteAccountUpsearchRequestModel';
export * from './enterpriseCoordinatorSiteAccountUpsearchResponseModel';
export * from './enterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel';
export * from './enterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel';
export * from './enterpriseCoordinatorSiteServiceModelsSiteUpsearchModel';
export * from './fullSurveySessionByIdsPostRequest';
export * from './fullSurveySessionPostRequest';
export * from './gatewayError';
export * from './generateAndSavePdfFromHtmlRequest';
export * from './generateAndSavePdfFromTemplateRequest';
export * from './generatePdfFromHtmlRequest';
export * from './generatePdfFromTemplateRequest';
export * from './generatePdfFromTemplateRequestContent';
export * from './generatePdfFromTemplateRequestContentPoint';
export * from './getAccountRequestModel';
export * from './getAccountResponseModel';
export * from './getBestEnrollmentRequest';
export * from './getBestEnrollmentResponse';
export * from './getBestEnrollmentV2RequestModel';
export * from './getCasePayorResponseModel';
export * from './getCasePayorResponseModelBenefitData';
export * from './getCasePharmacyResponseModel';
export * from './getCaseRequestModel';
export * from './getCaseResponseModel';
export * from './getCaseSiteResponseModel';
export * from './getCaseSurveyResponseModel';
export * from './getCasesRequestModel';
export * from './getDebitCardDetailRequestModel';
export * from './getEnrollmentDetailsRequestModel';
export * from './getLashPatientDebitCardLast4RequestModel';
export * from './getPatientAccountResponseModel';
export * from './getPatientRequestModel';
export * from './getSiteAccountsRequestModel';
export * from './getSiteAccountsResponseModel';
export * from './getWorkflowsRequestModel';
export * from './hcpIntakeRequestModel';
export * from './hcpIntakeResponseModel';
export * from './hubV1GetAccountDefaultResponse';
export * from './hubV1GetPatientDefaultResponse';
export * from './hubV1SavePatientDefaultResponse';
export * from './hubV1SavePatientDefaultResponseData';
export * from './hubV1SearchAccountsDefaultResponse';
export * from './hubV1SearchPatientsDefaultResponse';
export * from './hybridEnrollmentDemographicsModel';
export * from './hybridEnrollmentHistoryModel';
export * from './hybridEnrollmentRequestModel';
export * from './hybridEnrollmentResultModel';
export * from './hybridEnrollmentResultModelResponse';
export * from './iActivateUserRequestModel';
export * from './iAuthenticateAndCreateSessionRequest';
export * from './iAuthenticationData';
export * from './iAuthenticationResponseModel';
export * from './iCreateSessionRequest';
export * from './iExistingUserRequest';
export * from './iGetTasksRequestModel';
export * from './iIsPatientRegisteredRequestModel';
export * from './iPatientRegistrationData';
export * from './iPatientRegistrationRequestModel';
export * from './iSaveUserRoleRequestModel';
export * from './iSiteRegistrationData';
export * from './iSiteRegistrationRequestModel';
export * from './iTouchSessionRequest';
export * from './inlineObject';
export * from './intakeHcpIntakeDefaultResponse';
export * from './intakeIsHcpIntakeAllowedDefaultResponse';
export * from './intakePatientIntakeDefaultResponse';
export * from './intakePatientIntakeDefaultResponseData';
export * from './isEmailRegisteredRequestModel';
export * from './isHcpIntakeAllowedRequestModel';
export * from './isHcpIntakeAllowedRequestModelGender';
export * from './isHcpIntakeAllowedResponseModel';
export * from './isUnsubscribedRequestModel';
export * from './janssenGECheckRequestModel';
export * from './janssenGECheckResponseModel';
export * from './locationAddressCorrectionModel';
export * from './locationAddressModel';
export * from './locationCityModel';
export * from './locationCityModels';
export * from './locationSharedStateModel';
export * from './locationSharedStateModels';
export * from './locationValidAddressModel';
export * from './locationValidAddressModelResponse';
export * from './locationValidAddressResponseModel';
export * from './longDocumentDocumentCreateModelResponse';
export * from './mangoCardDetailsRequest';
export * from './mangoHubAddress';
export * from './mangoHubGetPatientAccountSummary';
export * from './mangoHubGetPatientInfo';
export * from './mangoHubGetPatientSummaryDetails';
export * from './mangoHubGetPatientSummaryDiagnosis';
export * from './mangoHubGetPatientSummaryMedicalPayor';
export * from './mangoHubGetPatientSummaryPharmacy';
export * from './mangoHubGetPatientSummaryPharmacyPayor';
export * from './mangoHubGetPatientSummaryPrescriber';
export * from './mangoHubGetPatientSummaryPrescription';
export * from './mangoHubGetPatientWelcomeSummaryResponse';
export * from './mangoHubGivePatientConsentResponse';
export * from './mangoHubPhone';
export * from './mangoHubRevokePatientConsentResponse';
export * from './mangoHubSelectedService';
export * from './mangoHubVerifyPatientRequest';
export * from './mangoHubVerifyPatientResponse';
export * from './mangoV1CardDetailsGetCardDetailsGetCardDetailsResponse';
export * from './medBenEnrollmentDemographicsModel';
export * from './medBenEnrollmentUpdateRequestModel';
export * from './medicalBenefitRequest';
export * from './medicalClaimSearchResponseModel';
export * from './medicalPayor';
export * from './memberNumberDetails';
export * from './noteConditionRelationshipModel';
export * from './noteTaskCreateModel';
export * from './noteTaskModel';
export * from './noteTaskModelResponse';
export * from './noteTaskModels';
export * from './noteTypeModel';
export * from './noteTypeModels';
export * from './patient';
export * from './patientAccountGetCaseDefaultResponse';
export * from './patientAccountGetPatientAccountDefaultResponse';
export * from './patientAccountGetPatientActiveEnrollmentsDefaultResponse';
export * from './patientAccountIsPatientRegisteredDefaultResponse';
export * from './patientAccountModel';
export * from './patientAccountPatientRegistrationDefaultResponse';
export * from './patientIntakeRequestModel';
export * from './patientModel';
export * from './patientModelResponse';
export * from './patientResponseModel';
export * from './patientSaveModel';
export * from './patientSearchModel';
export * from './patientSearchModelResponse';
export * from './patientSearchRequestModel';
export * from './patientSearchResponseModel';
export * from './patientSharedAddressModel';
export * from './patientSharedAddressUpsearchModel';
export * from './patientSharedEmailAddressModel';
export * from './patientSharedEmailAddressUpsearchModel';
export * from './patientSharedPhoneModel';
export * from './patientSharedPhoneUpsearchModel';
export * from './patientTCEntLib2SecuritySecureModelsSecureInt64Response';
export * from './patientUpsearchModel';
export * from './patientsSearchPatientsRequestModel';
export * from './payorAccountMedicalBenefitModel';
export * from './payorAccountMedicalBenefitModelResponse';
export * from './payorAccountMedicalBenefitModels';
export * from './payorAccountPharmacyBenefitModel';
export * from './payorAccountPharmacyBenefitModelResponse';
export * from './payorAccountPharmacyBenefitModels';
export * from './payorCoverageAreaModel';
export * from './payorCoverageEligibilityRequestModel';
export * from './payorLongResponse';
export * from './payorModel';
export * from './payorModelResponse';
export * from './payorPlanListRequestModel';
export * from './payorPlanModel';
export * from './payorPlanModels';
export * from './payorResponseModel';
export * from './payorRoleTypeModel';
export * from './payorRoleTypeModels';
export * from './payorSaveModel';
export * from './payorSearchModel';
export * from './payorSearchModelResponse';
export * from './payorSearchResponseModel';
export * from './payorSharedAddressModel';
export * from './payorSharedAddressUpsearchModel';
export * from './payorSharedContactUpsearchModel';
export * from './payorSharedEmailAddressModel';
export * from './payorSharedEmailAddressUpsearchModel';
export * from './payorSharedGlobalIdModel';
export * from './payorSharedPhoneModel';
export * from './payorSharedPhoneUpsearchModel';
export * from './payorSharedWebAddressModel';
export * from './payorSharedWebAddressUpsearchModel';
export * from './payorUpsearchModel';
export * from './pharmacy';
export * from './pharmacyClaimSearchResponseModel';
export * from './pharmacyLongResponse';
export * from './pharmacyModel';
export * from './pharmacyModelResponse';
export * from './pharmacyPayor';
export * from './pharmacyPointOfContactModel';
export * from './pharmacySearchModel';
export * from './pharmacySearchModelResponse';
export * from './pharmacySearchResponseModel';
export * from './pharmacySharedAddressModel';
export * from './pharmacySharedAddressUpsearchModel';
export * from './pharmacySharedContactUpsearchModel';
export * from './pharmacySharedEmailAddressModel';
export * from './pharmacySharedEmailAddressUpsearchModel';
export * from './pharmacySharedPhoneModel';
export * from './pharmacySharedPhoneUpsearchModel';
export * from './pharmacySharedWebAddressModel';
export * from './pharmacySharedWebAddressUpsearchModel';
export * from './pharmacyUpsearchModel';
export * from './plpAccountRegisterRegisterResponse';
export * from './plpPatientGetEnrollmentsGetEnrollmentsResponse';
export * from './plpPatientPatientLookupPatientLookupResponse';
export * from './prescriber';
export * from './prescriberLicenseModel';
export * from './prescriberLicenseUpsearchModel';
export * from './prescriberListRequestModel';
export * from './prescriberLongResponse';
export * from './prescriberModel';
export * from './prescriberModelResponse';
export * from './prescriberModels';
export * from './prescriberSearchModelResponse';
export * from './prescriberSearchRequestModel';
export * from './prescriberSearchResponseModel';
export * from './prescriberSharedAddressModel';
export * from './prescriberSharedAddressUpsearchModel';
export * from './prescriberSharedEmailAddressModel';
export * from './prescriberSharedEmailAddressUpsearchModel';
export * from './prescriberSharedExternalIdModel';
export * from './prescriberSharedExternalIdUpsearchModel';
export * from './prescriberSharedGlobalIdModel';
export * from './prescriberSharedPhoneModel';
export * from './prescriberSharedPhoneUpsearchModel';
export * from './prescriberSiteListPostRequest';
export * from './prescriberSiteSearchPostRequest';
export * from './prescriberUpsearchModel';
export * from './prescriptionExternalIdModel';
export * from './prescriptionModel';
export * from './prescriptionSignatureModel';
export * from './programModel';
export * from './programModelResponse';
export * from './programModels';
export * from './redemptionListRequestModel';
export * from './removePrescriberRequestModel';
export * from './removeSiteRequestModel';
export * from './replaceCardResultModel';
export * from './resetPasswordRequestModel';
export * from './savePatientRequestModel';
export * from './scriptsAccountGetUsersGetUsersContactInfoResponseModel';
export * from './scriptsAccountGetUsersGetUsersResponseModel';
export * from './scriptsAccountSaveUserSaveUserContactInfoRequestModel';
export * from './scriptsAccountSaveUserSaveUserRequestModel';
export * from './scriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel';
export * from './scriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel';
export * from './scriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel';
export * from './scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel';
export * from './scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel';
export * from './scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel';
export * from './scriptsDocumentsV2FillablePdfPdfFileData';
export * from './scriptsEnrollmentEnrollPatientEnrollmentInputModel';
export * from './scriptsMangoV1CardDetailsMedicalCard';
export * from './scriptsMangoV1CardDetailsPharmacyCard';
export * from './scriptsMangoV1CardDetailsVirtualDebitCard';
export * from './scriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel';
export * from './scriptsPlpAccountRegisterAccount';
export * from './scriptsPlpClaimSumbitClaimRequestModel';
export * from './scriptsPlpPatientPatientLookupResponseModel';
export * from './scriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel';
export * from './scriptsSiteAccountV2PatientsPatientAccountModel';
export * from './scriptsTempJanssenGECheckPatient';
export * from './searchAccountResponseModel';
export * from './searchAccountsRequestModel';
export * from './searchCasesRequestModel';
export * from './searchCasesResponseModel';
export * from './searchPatientsRequestModel';
export * from './searchWorkflowsRequestModel';
export * from './searchWorkflowsResponseModel';
export * from './secureUpsearchModelPatientPatientUpsearchModel';
export * from './sendRequestModel';
export * from './site';
export * from './siteAccountCancelWorkflowDefaultResponse';
export * from './siteAccountContact';
export * from './siteAccountGetAccountDefaultResponse';
export * from './siteAccountGetCaseDefaultResponse';
export * from './siteAccountGetCasesDefaultResponse';
export * from './siteAccountGetPartyDefaultResponse';
export * from './siteAccountGetSiteAccountDefaultResponse';
export * from './siteAccountGetWorkflowsDefaultResponse';
export * from './siteAccountModel';
export * from './siteAccountRequestModel';
export * from './siteAccountSearchAccountsDefaultResponse';
export * from './siteAccountSearchCasesDefaultResponse';
export * from './siteAccountSearchWorkflowsDefaultResponse';
export * from './siteAccountSiteRegistrationDefaultResponse';
export * from './siteAccountV2PatientsSearchPatientsSearchPatientsResponse';
export * from './siteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse';
export * from './siteDetails';
export * from './siteEnrollmentModel';
export * from './siteLongResponse';
export * from './siteModel';
export * from './siteModelResponse';
export * from './siteModels';
export * from './sitePointOfContactModel';
export * from './siteProcurementMethodModel';
export * from './siteSearchModelResponse';
export * from './siteSearchRequestModel';
export * from './siteSearchResponseModel';
export * from './siteSharedAddressModel';
export * from './siteSharedAddressUpsearchModel';
export * from './siteSharedContactModel';
export * from './siteSharedContactModels';
export * from './siteSharedContactPreferenceModel';
export * from './siteSharedContactUpsearchModel';
export * from './siteSharedEmailAddressModel';
export * from './siteSharedEmailAddressUpsearchModel';
export * from './siteSharedExternalIdModel';
export * from './siteSharedExternalIdUpsearchModel';
export * from './siteSharedGlobalIdModel';
export * from './siteSharedGlobalIdUpsearchModel';
export * from './siteSharedPhoneModel';
export * from './siteSharedPhoneUpsearchModel';
export * from './siteSharedWebAddressModel';
export * from './siteSharedWebAddressUpsearchModel';
export * from './siteUpsearchModel';
export * from './submitClaimResultModel';
export * from './submitClaimResultModelResponse';
export * from './surveyFullSurveySessionValuesModel';
export * from './surveyIdListRequestModel';
export * from './surveyQuestionCategoryModel';
export * from './surveyResponseModel';
export * from './surveySaveQuestionResultModelResponse';
export * from './surveySaveQuestionResultRequestModel';
export * from './surveySaveQuestionResultResponseModel';
export * from './surveySessionPostRequest';
export * from './surveySessionValueModel';
export * from './surveySessionValuePostRequest';
export * from './surveySessionValueReadModel';
export * from './surveySessionValueReadModels';
export * from './surveyStartSessionModelResponse';
export * from './surveyStartSessionRequestModel';
export * from './surveyStartSessionResponseModel';
export * from './tempGetNumberOfApplicationsDefaultResponse';
export * from './tempGetNumberOfApplicationsDefaultResponseData';
export * from './tempJanssenGeCheckDefaultResponse';
export * from './unsubscribeBySourceNameRequestModel';
export * from './unsubscribeRequestModel';
export * from './upsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel';
export * from './upsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel';
export * from './upsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel';
export * from './upsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel';
export * from './upsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel';
export * from './upsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel';
export * from './upsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel';
export * from './upsearchModelPayorPayorUpsearchModel';
export * from './upsearchModelPharmacyPharmacyUpsearchModel';
export * from './upsearchModelPrescriberPrescriberUpsearchModel';
export * from './upsearchModelSiteSiteUpsearchModel';
export * from './userRequestModel';
export * from './workflowModel';
import { ObjectSerializer } from '@trialcard/shared';
import { 
// @ts-ignore
AddressType, 
// @ts-ignore
RoleType, 
// @ts-ignore
ContactInfoType, 
// @ts-ignore
AccountExternalIdType, 
// @ts-ignore
AccountType, 
// @ts-ignore
AccountStatus, 
// @ts-ignore
ContactInfoPurposeType, 
// @ts-ignore
Extauth2ValidateStatus, 
// @ts-ignore
Extauth2ChangePasswordStatus, 
// @ts-ignore
AuthenticateStatus, 
// @ts-ignore
Extauth2ProfileUpdateStatus, 
// @ts-ignore
CommunicationTypesEnum, 
// @ts-ignore
SystemStatus, 
// @ts-ignore
CaseExternalIdType, 
// @ts-ignore
Gender, 
// @ts-ignore
ClaimTypeCode, 
// @ts-ignore
TCSEligibilityStatus, 
// @ts-ignore
TCSCommunicationType, 
// @ts-ignore
DebitCardMapStatus, 
// @ts-ignore
ProcessorType, 
// @ts-ignore
DebitCardVmcUsageRegion, 
// @ts-ignore
DiagnosisType, 
// @ts-ignore
DocumentGroupSource, 
// @ts-ignore
TransmissionType, 
// @ts-ignore
DocumentStatus, 
// @ts-ignore
DocumentGroupStatus, 
// @ts-ignore
EmailErrorCode, 
// @ts-ignore
MessageContentType, 
// @ts-ignore
EnrollPatientCaseInitiator, 
// @ts-ignore
AlternateCardType, 
// @ts-ignore
TCSSource, 
// @ts-ignore
TCSCommunicationOption, 
// @ts-ignore
EnrollmentStatus, 
// @ts-ignore
TCSRelationshipType, 
// @ts-ignore
TCSInsuranceType, 
// @ts-ignore
EnrollmentType, 
// @ts-ignore
EnrollmentApiPaymentType, 
// @ts-ignore
EnrollmentEligibility, 
// @ts-ignore
EnrollmentScenario, 
// @ts-ignore
ExternalIdType, 
// @ts-ignore
PlanType, 
// @ts-ignore
PayorType, 
// @ts-ignore
PharmacyType, 
// @ts-ignore
PharmacySpecialization, 
// @ts-ignore
PrescriberLicenseType, 
// @ts-ignore
PartyExternalIdType, 
// @ts-ignore
ContactDatePreferenceType, 
// @ts-ignore
ContactTimePreferenceType, 
// @ts-ignore
TCSPaymentType, 
// @ts-ignore
LocationCorrection, 
// @ts-ignore
Dpv, 
// @ts-ignore
NoteTypeCategory, 
// @ts-ignore
QueryStringMatch, 
// @ts-ignore
TCSSiteType, 
// @ts-ignore
TCSDocumentType, } from '@trialcard/enums';
import { AccountActivateUserDefaultResponse } from './accountActivateUserDefaultResponse';
import { AccountAddressModel } from './accountAddressModel';
import { AccountAttestationAttributeModel } from './accountAttestationAttributeModel';
import { AccountContactModel } from './accountContactModel';
import { AccountContactPreferenceModel } from './accountContactPreferenceModel';
import { AccountDocumentRelationshipModel } from './accountDocumentRelationshipModel';
import { AccountExternalIdModel } from './accountExternalIdModel';
import { AccountGetPrescribersDefaultResponse } from './accountGetPrescribersDefaultResponse';
import { AccountGetSitesDefaultResponse } from './accountGetSitesDefaultResponse';
import { AccountGetTasksDefaultResponse } from './accountGetTasksDefaultResponse';
import { AccountGetUsersDefaultResponse } from './accountGetUsersDefaultResponse';
import { AccountLinkedPayorModel } from './accountLinkedPayorModel';
import { AccountModel } from './accountModel';
import { AccountOptionalServiceModel } from './accountOptionalServiceModel';
import { AccountOrderRelationModel } from './accountOrderRelationModel';
import { AccountPayorRelationModel } from './accountPayorRelationModel';
import { AccountPhoneModel } from './accountPhoneModel';
import { AccountRelationModel } from './accountRelationModel';
import { AccountRemovePrescriberDefaultResponse } from './accountRemovePrescriberDefaultResponse';
import { AccountRemoveSiteDefaultResponse } from './accountRemoveSiteDefaultResponse';
import { AccountSavePrescriberDefaultResponse } from './accountSavePrescriberDefaultResponse';
import { AccountSaveSiteDefaultResponse } from './accountSaveSiteDefaultResponse';
import { AccountSaveTaskDefaultResponse } from './accountSaveTaskDefaultResponse';
import { AccountSaveUserDefaultResponse } from './accountSaveUserDefaultResponse';
import { AccountSaveUserRoleDefaultResponse } from './accountSaveUserRoleDefaultResponse';
import { AccountSessionModel } from './accountSessionModel';
import { AccountVoicemailOptInModel } from './accountVoicemailOptInModel';
import { Address } from './address';
import { AdminGetSiteAccountsDefaultResponse } from './adminGetSiteAccountsDefaultResponse';
import { AuthenticateUserRequestModel } from './authenticateUserRequestModel';
import { AuthenticationAuthenticateUserDefaultResponse } from './authenticationAuthenticateUserDefaultResponse';
import { AuthenticationChangePasswordDefaultResponse } from './authenticationChangePasswordDefaultResponse';
import { AuthenticationGetCurrentUserDefaultResponse } from './authenticationGetCurrentUserDefaultResponse';
import { AuthenticationIsEmailRegisteredDefaultResponse } from './authenticationIsEmailRegisteredDefaultResponse';
import { AuthenticationIsExistingUserResponse } from './authenticationIsExistingUserResponse';
import { AuthenticationResetPasswordDefaultResponse } from './authenticationResetPasswordDefaultResponse';
import { AuthenticationSaveCurrentUserDefaultResponse } from './authenticationSaveCurrentUserDefaultResponse';
import { AuthenticationTouchResponse } from './authenticationTouchResponse';
import { AuthenticationTouchResponseData } from './authenticationTouchResponseData';
import { AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse } from './authenticationV2UserCreatePortalAdminCreatePortalAdminResponse';
import { AuthenticationV2UserCreateStandardUserCreateStandardUserResponse } from './authenticationV2UserCreateStandardUserCreateStandardUserResponse';
import { AuthenticationV2UserDeleteUserIdDeleteUserResponse } from './authenticationV2UserDeleteUserIdDeleteUserResponse';
import { AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse } from './authenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse';
import { AuthenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse } from './authenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse';
import { AuthenticationV2UserUpdateUserIdUpdateUserResponse } from './authenticationV2UserUpdateUserIdUpdateUserResponse';
import { CancelWorkflowRequestModel } from './cancelWorkflowRequestModel';
import { CardAccumulatorModel } from './cardAccumulatorModel';
import { CardClaimAccumulatorModel } from './cardClaimAccumulatorModel';
import { CardClaimModel } from './cardClaimModel';
import { CardInternalStatusResultModel } from './cardInternalStatusResultModel';
import { CardMedicationModel } from './cardMedicationModel';
import { CardMemberNumberStatusResultModel } from './cardMemberNumberStatusResultModel';
import { CardMemberNumberStatusResultModelResponse } from './cardMemberNumberStatusResultModelResponse';
import { CardRedemptionListResultModel } from './cardRedemptionListResultModel';
import { CardTcsRedemptionListRecordModel } from './cardTcsRedemptionListRecordModel';
import { CaseAddressModel } from './caseAddressModel';
import { CaseAllowedCaseStatusModel } from './caseAllowedCaseStatusModel';
import { CaseAllowedCaseStatusModels } from './caseAllowedCaseStatusModels';
import { CaseAttestationAttributeModel } from './caseAttestationAttributeModel';
import { CaseConditionRelationshipModel } from './caseConditionRelationshipModel';
import { CaseContactPreferenceModel } from './caseContactPreferenceModel';
import { CaseDocumentRelationshipModel } from './caseDocumentRelationshipModel';
import { CaseExternalIdModel } from './caseExternalIdModel';
import { CaseHomeHealthAgencyRelationshipModel } from './caseHomeHealthAgencyRelationshipModel';
import { CaseModel } from './caseModel';
import { CaseOrderedRelationshipModel } from './caseOrderedRelationshipModel';
import { CasePayorRelationshipModel } from './casePayorRelationshipModel';
import { CasePhoneModel } from './casePhoneModel';
import { CasePrescriptionRelationshipModel } from './casePrescriptionRelationshipModel';
import { CaseProgramCaseTypeModel } from './caseProgramCaseTypeModel';
import { CaseProgramCaseTypeModels } from './caseProgramCaseTypeModels';
import { CaseRelationshipModel } from './caseRelationshipModel';
import { CaseSessionModel } from './caseSessionModel';
import { CaseTypeModel } from './caseTypeModel';
import { CaseTypeModels } from './caseTypeModels';
import { CaseTypeStatusModel } from './caseTypeStatusModel';
import { CaseTypeStatusModels } from './caseTypeStatusModels';
import { CaseWorkflowCaseModel } from './caseWorkflowCaseModel';
import { CaseWorkflowModel } from './caseWorkflowModel';
import { ChangePasswordRequestModel } from './changePasswordRequestModel';
import { ClaimAccumulatorModel } from './claimAccumulatorModel';
import { ClaimAccumulatorModels } from './claimAccumulatorModels';
import { ClaimAdjudicationClaimLineItem } from './claimAdjudicationClaimLineItem';
import { ClaimAdjudicationCodeModel } from './claimAdjudicationCodeModel';
import { ClaimAdjudicationMedicalInsurance } from './claimAdjudicationMedicalInsurance';
import { ClaimAdjudicationPatientDetails } from './claimAdjudicationPatientDetails';
import { ClaimAdjudicationPharmacyInsurance } from './claimAdjudicationPharmacyInsurance';
import { ClaimAdjudicationProviderDetails } from './claimAdjudicationProviderDetails';
import { ClaimAdjudicationRequest } from './claimAdjudicationRequest';
import { ClaimAdjudicationResponse } from './claimAdjudicationResponse';
import { ClaimAdjudicationResponseLineItem } from './claimAdjudicationResponseLineItem';
import { ClaimConditionModel } from './claimConditionModel';
import { ClaimDetailsResponseModel } from './claimDetailsResponseModel';
import { ClaimExternalReferenceModel } from './claimExternalReferenceModel';
import { ClaimFileOutputModel } from './claimFileOutputModel';
import { ClaimKeyValuePairLongString } from './claimKeyValuePairLongString';
import { ClaimLookupModel } from './claimLookupModel';
import { ClaimMedicalClaimModel } from './claimMedicalClaimModel';
import { ClaimMedicalClaimSearchModel } from './claimMedicalClaimSearchModel';
import { ClaimPayorModel } from './claimPayorModel';
import { ClaimPharmacyClaimModel } from './claimPharmacyClaimModel';
import { ClaimProviderLocationModel } from './claimProviderLocationModel';
import { ClaimProviderModel } from './claimProviderModel';
import { ClaimSearchModel } from './claimSearchModel';
import { ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest } from './claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest';
import { ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse } from './claimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse';
import { ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest } from './claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest';
import { ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse } from './claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse';
import { Contact } from './contact';
import { CouponDocumentsSubmitDocumentsSubmitDocumentsRequest } from './couponDocumentsSubmitDocumentsSubmitDocumentsRequest';
import { CouponDocumentsSubmitDocumentsSubmitDocumentsResponse } from './couponDocumentsSubmitDocumentsSubmitDocumentsResponse';
import { CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse } from './couponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse';
import { CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse } from './couponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse';
import { CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse } from './couponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse';
import { CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse } from './couponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse';
import { CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse } from './couponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse';
import { CouponGetEnrollmentDetailsDefaultResponse } from './couponGetEnrollmentDetailsDefaultResponse';
import { CouponGetEnrollmentDetailsDefaultResponseData } from './couponGetEnrollmentDetailsDefaultResponseData';
import { CouponMemberMemberNumberStatusMemberNumberStatusRequest } from './couponMemberMemberNumberStatusMemberNumberStatusRequest';
import { CouponMemberMemberNumberStatusMemberNumberStatusResponse } from './couponMemberMemberNumberStatusMemberNumberStatusResponse';
import { CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest } from './couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest';
import { CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse } from './couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse';
import { CouponMemberReplaceCardReplaceCardRequest } from './couponMemberReplaceCardReplaceCardRequest';
import { CouponMemberReplaceCardReplaceCardResponse } from './couponMemberReplaceCardReplaceCardResponse';
import { CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse } from './couponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse';
import { CouponPatientPatientSearchPatientSearchResponse } from './couponPatientPatientSearchPatientSearchResponse';
import { CouponRedemptionListListResponse } from './couponRedemptionListListResponse';
import { CouponSubmitDocumentsRequestModel } from './couponSubmitDocumentsRequestModel';
import { DeactivateEnrollmentRequest } from './deactivateEnrollmentRequest';
import { DebitCardGetDebitCardDetailDefaultResponse } from './debitCardGetDebitCardDetailDefaultResponse';
import { DebitCardGetLashPatientDebitCardLast4DefaultResponse } from './debitCardGetLashPatientDebitCardLast4DefaultResponse';
import { DebitCardInfoResponseModel } from './debitCardInfoResponseModel';
import { DiagnosisModel } from './diagnosisModel';
import { DiagnosisModelResponse } from './diagnosisModelResponse';
import { DiagnosisModels } from './diagnosisModels';
import { DiagnosisSearchModelResponse } from './diagnosisSearchModelResponse';
import { DiagnosisSearchRequestModel } from './diagnosisSearchRequestModel';
import { DiagnosisSearchResponseModel } from './diagnosisSearchResponseModel';
import { DocumentCreateModel } from './documentCreateModel';
import { DocumentCreateResponseModel } from './documentCreateResponseModel';
import { DocumentLinkModel } from './documentLinkModel';
import { DocumentLongResponse } from './documentLongResponse';
import { DocumentModel } from './documentModel';
import { DocumentModelResponse } from './documentModelResponse';
import { DocumentParentLinkModel } from './documentParentLinkModel';
import { DocumentPdfDocumentModel } from './documentPdfDocumentModel';
import { DocumentPdfFileModel } from './documentPdfFileModel';
import { DocumentPdfFileStyleModel } from './documentPdfFileStyleModel';
import { DocumentsV1DocumentUploadUploadResponse } from './documentsV1DocumentUploadUploadResponse';
import { DocumentsV1GeneratePdfFromHtmlSaveSaveResponse } from './documentsV1GeneratePdfFromHtmlSaveSaveResponse';
import { DocumentsV1GeneratePdfFromTemplateSaveSaveResponse } from './documentsV1GeneratePdfFromTemplateSaveSaveResponse';
import { DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse } from './documentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse';
import { EmailEmailContact } from './emailEmailContact';
import { EmailIsUnsubscribedDefaultResponse } from './emailIsUnsubscribedDefaultResponse';
import { EmailReturnResult } from './emailReturnResult';
import { EmailReturnResultResponse } from './emailReturnResultResponse';
import { EmailSendDefaultResponse } from './emailSendDefaultResponse';
import { EmailSendEmailSingle } from './emailSendEmailSingle';
import { EmailUnsubscribeDefaultResponse } from './emailUnsubscribeDefaultResponse';
import { EnrollPatientRequestModel } from './enrollPatientRequestModel';
import { EnrollPatientResponse } from './enrollPatientResponse';
import { EnrollmentAccumulatorModel } from './enrollmentAccumulatorModel';
import { EnrollmentAlternateCardId } from './enrollmentAlternateCardId';
import { EnrollmentCaseDocumentRelationshipModel } from './enrollmentCaseDocumentRelationshipModel';
import { EnrollmentCaseOrderedRelationshipModel } from './enrollmentCaseOrderedRelationshipModel';
import { EnrollmentCasePrescriptionRelationshipModel } from './enrollmentCasePrescriptionRelationshipModel';
import { EnrollmentCaseRelationshipModel } from './enrollmentCaseRelationshipModel';
import { EnrollmentCaseRelationshipsModel } from './enrollmentCaseRelationshipsModel';
import { EnrollmentCaseRoleTypeRelationshipModel } from './enrollmentCaseRoleTypeRelationshipModel';
import { EnrollmentCheckMemberNumberDefaultResponse } from './enrollmentCheckMemberNumberDefaultResponse';
import { EnrollmentClientIdentifiersModel } from './enrollmentClientIdentifiersModel';
import { EnrollmentCommTypeUpdateRequestModel } from './enrollmentCommTypeUpdateRequestModel';
import { EnrollmentConditionTypeModel } from './enrollmentConditionTypeModel';
import { EnrollmentCreatePrescriberRequestModel } from './enrollmentCreatePrescriberRequestModel';
import { EnrollmentCreatePrescriberResultModel } from './enrollmentCreatePrescriberResultModel';
import { EnrollmentCreatePrescriberResultModelResponse } from './enrollmentCreatePrescriberResultModelResponse';
import { EnrollmentCreateSiteRequestModel } from './enrollmentCreateSiteRequestModel';
import { EnrollmentCreateSiteResultModel } from './enrollmentCreateSiteResultModel';
import { EnrollmentCreateSiteResultModelResponse } from './enrollmentCreateSiteResultModelResponse';
import { EnrollmentDeactivateResponse } from './enrollmentDeactivateResponse';
import { EnrollmentDemographicsModel } from './enrollmentDemographicsModel';
import { EnrollmentDocumentModel } from './enrollmentDocumentModel';
import { EnrollmentEligibilityModel } from './enrollmentEligibilityModel';
import { EnrollmentEnrollPatientDefaultResponse } from './enrollmentEnrollPatientDefaultResponse';
import { EnrollmentGetBestEnrollmentDefaultResponse } from './enrollmentGetBestEnrollmentDefaultResponse';
import { EnrollmentGetBestEnrollmentsV2DefaultResponse } from './enrollmentGetBestEnrollmentsV2DefaultResponse';
import { EnrollmentGuardianInfoModel } from './enrollmentGuardianInfoModel';
import { EnrollmentHistoryModel } from './enrollmentHistoryModel';
import { EnrollmentHybridPatientSearchResultModel } from './enrollmentHybridPatientSearchResultModel';
import { EnrollmentInsVerRequestModel } from './enrollmentInsVerRequestModel';
import { EnrollmentInsuranceVerificationModel } from './enrollmentInsuranceVerificationModel';
import { EnrollmentIsValidMemberNumberModel } from './enrollmentIsValidMemberNumberModel';
import { EnrollmentIsValidMemberNumberModelResponse } from './enrollmentIsValidMemberNumberModelResponse';
import { EnrollmentIsValidMemberNumberRequestModel } from './enrollmentIsValidMemberNumberRequestModel';
import { EnrollmentMedBenClientIdentifiersModel } from './enrollmentMedBenClientIdentifiersModel';
import { EnrollmentMedBenInsuranceVerificationModel } from './enrollmentMedBenInsuranceVerificationModel';
import { EnrollmentMedicationModel } from './enrollmentMedicationModel';
import { EnrollmentMemberNumberModel } from './enrollmentMemberNumberModel';
import { EnrollmentModel } from './enrollmentModel';
import { EnrollmentPatientLookupRequestModel } from './enrollmentPatientLookupRequestModel';
import { EnrollmentPatientLookupResultModel } from './enrollmentPatientLookupResultModel';
import { EnrollmentPatientSearchRecordModel } from './enrollmentPatientSearchRecordModel';
import { EnrollmentPatientSearchResultModel } from './enrollmentPatientSearchResultModel';
import { EnrollmentPatientUpdateDemographicsModel } from './enrollmentPatientUpdateDemographicsModel';
import { EnrollmentPatientUpdateRequestModel } from './enrollmentPatientUpdateRequestModel';
import { EnrollmentPhoneNumberModel } from './enrollmentPhoneNumberModel';
import { EnrollmentRequest } from './enrollmentRequest';
import { EnrollmentRequestModel } from './enrollmentRequestModel';
import { EnrollmentResponse } from './enrollmentResponse';
import { EnrollmentResponseModel } from './enrollmentResponseModel';
import { EnrollmentResultModel } from './enrollmentResultModel';
import { EnrollmentResultModelResponse } from './enrollmentResultModelResponse';
import { EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel } from './enrollmentServiceV2PublicModelsRulesMetaRuleResultModel';
import { EnrollmentSurveyQuestionModel } from './enrollmentSurveyQuestionModel';
import { EnrollmentUpdateRequestModel } from './enrollmentUpdateRequestModel';
import { EnrollmentV2ConditionTypeModel } from './enrollmentV2ConditionTypeModel';
import { EnrollmentV2EligibilityModel } from './enrollmentV2EligibilityModel';
import { EnrollmentV2EnrollmentModel } from './enrollmentV2EnrollmentModel';
import { EnrollmentV2MemberNumberModel } from './enrollmentV2MemberNumberModel';
import { EnrollmentV2ProcessingBenefitModel } from './enrollmentV2ProcessingBenefitModel';
import { EnrollmentV2ProcessingOutcomeModel } from './enrollmentV2ProcessingOutcomeModel';
import { EnrollmentV2ProcessingResultModel } from './enrollmentV2ProcessingResultModel';
import { EnrollmentV2RulesAssignMemberNumberResultModel } from './enrollmentV2RulesAssignMemberNumberResultModel';
import { EnrollmentV2RulesMemberNumberBucketResult } from './enrollmentV2RulesMemberNumberBucketResult';
import { EnrollmentVerifySurveyEntryRequestModel } from './enrollmentVerifySurveyEntryRequestModel';
import { EnrollmentVerifySurveyEntryResultModel } from './enrollmentVerifySurveyEntryResultModel';
import { EnrollmentVerifySurveyEntryResultModelResponse } from './enrollmentVerifySurveyEntryResultModelResponse';
import { EnterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel } from './enterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel } from './enterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel } from './enterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel } from './enterpriseCoordinatorAccountServiceModelsAccountExternalIdModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel } from './enterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel } from './enterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel } from './enterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountRelationModel } from './enterpriseCoordinatorAccountServiceModelsAccountRelationModel';
import { EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel } from './enterpriseCoordinatorAccountServiceModelsAccountUpsearchModel';
import { EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel } from './enterpriseCoordinatorAccountServiceModelsVoicemailOptInModel';
import { EnterpriseCoordinatorAccountUpsearchModelResponse } from './enterpriseCoordinatorAccountUpsearchModelResponse';
import { EnterpriseCoordinatorAccountUpsearchRequestModel } from './enterpriseCoordinatorAccountUpsearchRequestModel';
import { EnterpriseCoordinatorAccountUpsearchResponseModel } from './enterpriseCoordinatorAccountUpsearchResponseModel';
import { EnterpriseCoordinatorCaseDocumentRelationshipModel } from './enterpriseCoordinatorCaseDocumentRelationshipModel';
import { EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel } from './enterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel';
import { EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel } from './enterpriseCoordinatorPatientServiceModelsPatientUpsearchModel';
import { EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel } from './enterpriseCoordinatorPayorServiceModelsPayorBenefitModel';
import { EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel } from './enterpriseCoordinatorPayorServiceModelsPayorUpsearchModel';
import { EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel } from './enterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel';
import { EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel } from './enterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel';
import { EnterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel } from './enterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel';
import { EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel } from './enterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel';
import { EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel } from './enterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel';
import { EnterpriseCoordinatorSharedAddressUpsearchModel } from './enterpriseCoordinatorSharedAddressUpsearchModel';
import { EnterpriseCoordinatorSharedContactUpsearchModel } from './enterpriseCoordinatorSharedContactUpsearchModel';
import { EnterpriseCoordinatorSharedEmailAddressUpsearchModel } from './enterpriseCoordinatorSharedEmailAddressUpsearchModel';
import { EnterpriseCoordinatorSharedExternalIdUpsearchModel } from './enterpriseCoordinatorSharedExternalIdUpsearchModel';
import { EnterpriseCoordinatorSharedGlobalIdUpsearchModel } from './enterpriseCoordinatorSharedGlobalIdUpsearchModel';
import { EnterpriseCoordinatorSharedPhoneUpsearchModel } from './enterpriseCoordinatorSharedPhoneUpsearchModel';
import { EnterpriseCoordinatorSharedWebAddressUpsearchModel } from './enterpriseCoordinatorSharedWebAddressUpsearchModel';
import { EnterpriseCoordinatorSiteAccountUpsearchModelResponse } from './enterpriseCoordinatorSiteAccountUpsearchModelResponse';
import { EnterpriseCoordinatorSiteAccountUpsearchRequestModel } from './enterpriseCoordinatorSiteAccountUpsearchRequestModel';
import { EnterpriseCoordinatorSiteAccountUpsearchResponseModel } from './enterpriseCoordinatorSiteAccountUpsearchResponseModel';
import { EnterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel } from './enterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel';
import { EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel } from './enterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel';
import { EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel } from './enterpriseCoordinatorSiteServiceModelsSiteUpsearchModel';
import { FullSurveySessionByIdsPostRequest } from './fullSurveySessionByIdsPostRequest';
import { FullSurveySessionPostRequest } from './fullSurveySessionPostRequest';
import { GatewayError } from './gatewayError';
import { GenerateAndSavePdfFromHtmlRequest } from './generateAndSavePdfFromHtmlRequest';
import { GenerateAndSavePdfFromTemplateRequest } from './generateAndSavePdfFromTemplateRequest';
import { GeneratePdfFromHtmlRequest } from './generatePdfFromHtmlRequest';
import { GeneratePdfFromTemplateRequest } from './generatePdfFromTemplateRequest';
import { GeneratePdfFromTemplateRequestContent } from './generatePdfFromTemplateRequestContent';
import { GeneratePdfFromTemplateRequestContentPoint } from './generatePdfFromTemplateRequestContentPoint';
import { GetAccountRequestModel } from './getAccountRequestModel';
import { GetAccountResponseModel } from './getAccountResponseModel';
import { GetBestEnrollmentRequest } from './getBestEnrollmentRequest';
import { GetBestEnrollmentResponse } from './getBestEnrollmentResponse';
import { GetBestEnrollmentV2RequestModel } from './getBestEnrollmentV2RequestModel';
import { GetCasePayorResponseModel } from './getCasePayorResponseModel';
import { GetCasePayorResponseModelBenefitData } from './getCasePayorResponseModelBenefitData';
import { GetCasePharmacyResponseModel } from './getCasePharmacyResponseModel';
import { GetCaseRequestModel } from './getCaseRequestModel';
import { GetCaseResponseModel } from './getCaseResponseModel';
import { GetCaseSiteResponseModel } from './getCaseSiteResponseModel';
import { GetCaseSurveyResponseModel } from './getCaseSurveyResponseModel';
import { GetCasesRequestModel } from './getCasesRequestModel';
import { GetDebitCardDetailRequestModel } from './getDebitCardDetailRequestModel';
import { GetEnrollmentDetailsRequestModel } from './getEnrollmentDetailsRequestModel';
import { GetLashPatientDebitCardLast4RequestModel } from './getLashPatientDebitCardLast4RequestModel';
import { GetPatientAccountResponseModel } from './getPatientAccountResponseModel';
import { GetPatientRequestModel } from './getPatientRequestModel';
import { GetSiteAccountsRequestModel } from './getSiteAccountsRequestModel';
import { GetSiteAccountsResponseModel } from './getSiteAccountsResponseModel';
import { GetWorkflowsRequestModel } from './getWorkflowsRequestModel';
import { HcpIntakeRequestModel } from './hcpIntakeRequestModel';
import { HcpIntakeResponseModel } from './hcpIntakeResponseModel';
import { HubV1GetAccountDefaultResponse } from './hubV1GetAccountDefaultResponse';
import { HubV1GetPatientDefaultResponse } from './hubV1GetPatientDefaultResponse';
import { HubV1SavePatientDefaultResponse } from './hubV1SavePatientDefaultResponse';
import { HubV1SavePatientDefaultResponseData } from './hubV1SavePatientDefaultResponseData';
import { HubV1SearchAccountsDefaultResponse } from './hubV1SearchAccountsDefaultResponse';
import { HubV1SearchPatientsDefaultResponse } from './hubV1SearchPatientsDefaultResponse';
import { HybridEnrollmentDemographicsModel } from './hybridEnrollmentDemographicsModel';
import { HybridEnrollmentHistoryModel } from './hybridEnrollmentHistoryModel';
import { HybridEnrollmentRequestModel } from './hybridEnrollmentRequestModel';
import { HybridEnrollmentResultModel } from './hybridEnrollmentResultModel';
import { HybridEnrollmentResultModelResponse } from './hybridEnrollmentResultModelResponse';
import { IActivateUserRequestModel } from './iActivateUserRequestModel';
import { IAuthenticateAndCreateSessionRequest } from './iAuthenticateAndCreateSessionRequest';
import { IAuthenticationData } from './iAuthenticationData';
import { IAuthenticationResponseModel } from './iAuthenticationResponseModel';
import { ICreateSessionRequest } from './iCreateSessionRequest';
import { IExistingUserRequest } from './iExistingUserRequest';
import { IGetTasksRequestModel } from './iGetTasksRequestModel';
import { IIsPatientRegisteredRequestModel } from './iIsPatientRegisteredRequestModel';
import { IPatientRegistrationData } from './iPatientRegistrationData';
import { IPatientRegistrationRequestModel } from './iPatientRegistrationRequestModel';
import { ISaveUserRoleRequestModel } from './iSaveUserRoleRequestModel';
import { ISiteRegistrationData } from './iSiteRegistrationData';
import { ISiteRegistrationRequestModel } from './iSiteRegistrationRequestModel';
import { ITouchSessionRequest } from './iTouchSessionRequest';
import { InlineObject } from './inlineObject';
import { IntakeHcpIntakeDefaultResponse } from './intakeHcpIntakeDefaultResponse';
import { IntakeIsHcpIntakeAllowedDefaultResponse } from './intakeIsHcpIntakeAllowedDefaultResponse';
import { IntakePatientIntakeDefaultResponse } from './intakePatientIntakeDefaultResponse';
import { IntakePatientIntakeDefaultResponseData } from './intakePatientIntakeDefaultResponseData';
import { IsEmailRegisteredRequestModel } from './isEmailRegisteredRequestModel';
import { IsHcpIntakeAllowedRequestModel } from './isHcpIntakeAllowedRequestModel';
import { IsHcpIntakeAllowedRequestModelGender } from './isHcpIntakeAllowedRequestModelGender';
import { IsHcpIntakeAllowedResponseModel } from './isHcpIntakeAllowedResponseModel';
import { IsUnsubscribedRequestModel } from './isUnsubscribedRequestModel';
import { JanssenGECheckRequestModel } from './janssenGECheckRequestModel';
import { JanssenGECheckResponseModel } from './janssenGECheckResponseModel';
import { LocationAddressCorrectionModel } from './locationAddressCorrectionModel';
import { LocationAddressModel } from './locationAddressModel';
import { LocationCityModel } from './locationCityModel';
import { LocationCityModels } from './locationCityModels';
import { LocationSharedStateModel } from './locationSharedStateModel';
import { LocationSharedStateModels } from './locationSharedStateModels';
import { LocationValidAddressModel } from './locationValidAddressModel';
import { LocationValidAddressModelResponse } from './locationValidAddressModelResponse';
import { LocationValidAddressResponseModel } from './locationValidAddressResponseModel';
import { LongDocumentDocumentCreateModelResponse } from './longDocumentDocumentCreateModelResponse';
import { MangoCardDetailsRequest } from './mangoCardDetailsRequest';
import { MangoHubAddress } from './mangoHubAddress';
import { MangoHubGetPatientAccountSummary } from './mangoHubGetPatientAccountSummary';
import { MangoHubGetPatientInfo } from './mangoHubGetPatientInfo';
import { MangoHubGetPatientSummaryDetails } from './mangoHubGetPatientSummaryDetails';
import { MangoHubGetPatientSummaryDiagnosis } from './mangoHubGetPatientSummaryDiagnosis';
import { MangoHubGetPatientSummaryMedicalPayor } from './mangoHubGetPatientSummaryMedicalPayor';
import { MangoHubGetPatientSummaryPharmacy } from './mangoHubGetPatientSummaryPharmacy';
import { MangoHubGetPatientSummaryPharmacyPayor } from './mangoHubGetPatientSummaryPharmacyPayor';
import { MangoHubGetPatientSummaryPrescriber } from './mangoHubGetPatientSummaryPrescriber';
import { MangoHubGetPatientSummaryPrescription } from './mangoHubGetPatientSummaryPrescription';
import { MangoHubGetPatientWelcomeSummaryResponse } from './mangoHubGetPatientWelcomeSummaryResponse';
import { MangoHubGivePatientConsentResponse } from './mangoHubGivePatientConsentResponse';
import { MangoHubPhone } from './mangoHubPhone';
import { MangoHubRevokePatientConsentResponse } from './mangoHubRevokePatientConsentResponse';
import { MangoHubSelectedService } from './mangoHubSelectedService';
import { MangoHubVerifyPatientRequest } from './mangoHubVerifyPatientRequest';
import { MangoHubVerifyPatientResponse } from './mangoHubVerifyPatientResponse';
import { MangoV1CardDetailsGetCardDetailsGetCardDetailsResponse } from './mangoV1CardDetailsGetCardDetailsGetCardDetailsResponse';
import { MedBenEnrollmentDemographicsModel } from './medBenEnrollmentDemographicsModel';
import { MedBenEnrollmentUpdateRequestModel } from './medBenEnrollmentUpdateRequestModel';
import { MedicalBenefitRequest } from './medicalBenefitRequest';
import { MedicalClaimSearchResponseModel } from './medicalClaimSearchResponseModel';
import { MedicalPayor } from './medicalPayor';
import { MemberNumberDetails } from './memberNumberDetails';
import { NoteConditionRelationshipModel } from './noteConditionRelationshipModel';
import { NoteTaskCreateModel } from './noteTaskCreateModel';
import { NoteTaskModel } from './noteTaskModel';
import { NoteTaskModelResponse } from './noteTaskModelResponse';
import { NoteTaskModels } from './noteTaskModels';
import { NoteTypeModel } from './noteTypeModel';
import { NoteTypeModels } from './noteTypeModels';
import { Patient } from './patient';
import { PatientAccountGetCaseDefaultResponse } from './patientAccountGetCaseDefaultResponse';
import { PatientAccountGetPatientAccountDefaultResponse } from './patientAccountGetPatientAccountDefaultResponse';
import { PatientAccountGetPatientActiveEnrollmentsDefaultResponse } from './patientAccountGetPatientActiveEnrollmentsDefaultResponse';
import { PatientAccountIsPatientRegisteredDefaultResponse } from './patientAccountIsPatientRegisteredDefaultResponse';
import { PatientAccountModel } from './patientAccountModel';
import { PatientAccountPatientRegistrationDefaultResponse } from './patientAccountPatientRegistrationDefaultResponse';
import { PatientIntakeRequestModel } from './patientIntakeRequestModel';
import { PatientModel } from './patientModel';
import { PatientModelResponse } from './patientModelResponse';
import { PatientResponseModel } from './patientResponseModel';
import { PatientSaveModel } from './patientSaveModel';
import { PatientSearchModel } from './patientSearchModel';
import { PatientSearchModelResponse } from './patientSearchModelResponse';
import { PatientSearchRequestModel } from './patientSearchRequestModel';
import { PatientSearchResponseModel } from './patientSearchResponseModel';
import { PatientSharedAddressModel } from './patientSharedAddressModel';
import { PatientSharedAddressUpsearchModel } from './patientSharedAddressUpsearchModel';
import { PatientSharedEmailAddressModel } from './patientSharedEmailAddressModel';
import { PatientSharedEmailAddressUpsearchModel } from './patientSharedEmailAddressUpsearchModel';
import { PatientSharedPhoneModel } from './patientSharedPhoneModel';
import { PatientSharedPhoneUpsearchModel } from './patientSharedPhoneUpsearchModel';
import { PatientTCEntLib2SecuritySecureModelsSecureInt64Response } from './patientTCEntLib2SecuritySecureModelsSecureInt64Response';
import { PatientUpsearchModel } from './patientUpsearchModel';
import { PatientsSearchPatientsRequestModel } from './patientsSearchPatientsRequestModel';
import { PayorAccountMedicalBenefitModel } from './payorAccountMedicalBenefitModel';
import { PayorAccountMedicalBenefitModelResponse } from './payorAccountMedicalBenefitModelResponse';
import { PayorAccountMedicalBenefitModels } from './payorAccountMedicalBenefitModels';
import { PayorAccountPharmacyBenefitModel } from './payorAccountPharmacyBenefitModel';
import { PayorAccountPharmacyBenefitModelResponse } from './payorAccountPharmacyBenefitModelResponse';
import { PayorAccountPharmacyBenefitModels } from './payorAccountPharmacyBenefitModels';
import { PayorCoverageAreaModel } from './payorCoverageAreaModel';
import { PayorCoverageEligibilityRequestModel } from './payorCoverageEligibilityRequestModel';
import { PayorLongResponse } from './payorLongResponse';
import { PayorModel } from './payorModel';
import { PayorModelResponse } from './payorModelResponse';
import { PayorPlanListRequestModel } from './payorPlanListRequestModel';
import { PayorPlanModel } from './payorPlanModel';
import { PayorPlanModels } from './payorPlanModels';
import { PayorResponseModel } from './payorResponseModel';
import { PayorRoleTypeModel } from './payorRoleTypeModel';
import { PayorRoleTypeModels } from './payorRoleTypeModels';
import { PayorSaveModel } from './payorSaveModel';
import { PayorSearchModel } from './payorSearchModel';
import { PayorSearchModelResponse } from './payorSearchModelResponse';
import { PayorSearchResponseModel } from './payorSearchResponseModel';
import { PayorSharedAddressModel } from './payorSharedAddressModel';
import { PayorSharedAddressUpsearchModel } from './payorSharedAddressUpsearchModel';
import { PayorSharedContactUpsearchModel } from './payorSharedContactUpsearchModel';
import { PayorSharedEmailAddressModel } from './payorSharedEmailAddressModel';
import { PayorSharedEmailAddressUpsearchModel } from './payorSharedEmailAddressUpsearchModel';
import { PayorSharedGlobalIdModel } from './payorSharedGlobalIdModel';
import { PayorSharedPhoneModel } from './payorSharedPhoneModel';
import { PayorSharedPhoneUpsearchModel } from './payorSharedPhoneUpsearchModel';
import { PayorSharedWebAddressModel } from './payorSharedWebAddressModel';
import { PayorSharedWebAddressUpsearchModel } from './payorSharedWebAddressUpsearchModel';
import { PayorUpsearchModel } from './payorUpsearchModel';
import { Pharmacy } from './pharmacy';
import { PharmacyClaimSearchResponseModel } from './pharmacyClaimSearchResponseModel';
import { PharmacyLongResponse } from './pharmacyLongResponse';
import { PharmacyModel } from './pharmacyModel';
import { PharmacyModelResponse } from './pharmacyModelResponse';
import { PharmacyPayor } from './pharmacyPayor';
import { PharmacyPointOfContactModel } from './pharmacyPointOfContactModel';
import { PharmacySearchModel } from './pharmacySearchModel';
import { PharmacySearchModelResponse } from './pharmacySearchModelResponse';
import { PharmacySearchResponseModel } from './pharmacySearchResponseModel';
import { PharmacySharedAddressModel } from './pharmacySharedAddressModel';
import { PharmacySharedAddressUpsearchModel } from './pharmacySharedAddressUpsearchModel';
import { PharmacySharedContactUpsearchModel } from './pharmacySharedContactUpsearchModel';
import { PharmacySharedEmailAddressModel } from './pharmacySharedEmailAddressModel';
import { PharmacySharedEmailAddressUpsearchModel } from './pharmacySharedEmailAddressUpsearchModel';
import { PharmacySharedPhoneModel } from './pharmacySharedPhoneModel';
import { PharmacySharedPhoneUpsearchModel } from './pharmacySharedPhoneUpsearchModel';
import { PharmacySharedWebAddressModel } from './pharmacySharedWebAddressModel';
import { PharmacySharedWebAddressUpsearchModel } from './pharmacySharedWebAddressUpsearchModel';
import { PharmacyUpsearchModel } from './pharmacyUpsearchModel';
import { PlpAccountRegisterRegisterResponse } from './plpAccountRegisterRegisterResponse';
import { PlpPatientGetEnrollmentsGetEnrollmentsResponse } from './plpPatientGetEnrollmentsGetEnrollmentsResponse';
import { PlpPatientPatientLookupPatientLookupResponse } from './plpPatientPatientLookupPatientLookupResponse';
import { Prescriber } from './prescriber';
import { PrescriberLicenseModel } from './prescriberLicenseModel';
import { PrescriberLicenseUpsearchModel } from './prescriberLicenseUpsearchModel';
import { PrescriberListRequestModel } from './prescriberListRequestModel';
import { PrescriberLongResponse } from './prescriberLongResponse';
import { PrescriberModel } from './prescriberModel';
import { PrescriberModelResponse } from './prescriberModelResponse';
import { PrescriberModels } from './prescriberModels';
import { PrescriberSearchModelResponse } from './prescriberSearchModelResponse';
import { PrescriberSearchRequestModel } from './prescriberSearchRequestModel';
import { PrescriberSearchResponseModel } from './prescriberSearchResponseModel';
import { PrescriberSharedAddressModel } from './prescriberSharedAddressModel';
import { PrescriberSharedAddressUpsearchModel } from './prescriberSharedAddressUpsearchModel';
import { PrescriberSharedEmailAddressModel } from './prescriberSharedEmailAddressModel';
import { PrescriberSharedEmailAddressUpsearchModel } from './prescriberSharedEmailAddressUpsearchModel';
import { PrescriberSharedExternalIdModel } from './prescriberSharedExternalIdModel';
import { PrescriberSharedExternalIdUpsearchModel } from './prescriberSharedExternalIdUpsearchModel';
import { PrescriberSharedGlobalIdModel } from './prescriberSharedGlobalIdModel';
import { PrescriberSharedPhoneModel } from './prescriberSharedPhoneModel';
import { PrescriberSharedPhoneUpsearchModel } from './prescriberSharedPhoneUpsearchModel';
import { PrescriberSiteListPostRequest } from './prescriberSiteListPostRequest';
import { PrescriberSiteSearchPostRequest } from './prescriberSiteSearchPostRequest';
import { PrescriberUpsearchModel } from './prescriberUpsearchModel';
import { PrescriptionExternalIdModel } from './prescriptionExternalIdModel';
import { PrescriptionModel } from './prescriptionModel';
import { PrescriptionSignatureModel } from './prescriptionSignatureModel';
import { ProgramModel } from './programModel';
import { ProgramModelResponse } from './programModelResponse';
import { ProgramModels } from './programModels';
import { RedemptionListRequestModel } from './redemptionListRequestModel';
import { RemovePrescriberRequestModel } from './removePrescriberRequestModel';
import { RemoveSiteRequestModel } from './removeSiteRequestModel';
import { ReplaceCardResultModel } from './replaceCardResultModel';
import { ResetPasswordRequestModel } from './resetPasswordRequestModel';
import { SavePatientRequestModel } from './savePatientRequestModel';
import { ScriptsAccountGetUsersGetUsersContactInfoResponseModel } from './scriptsAccountGetUsersGetUsersContactInfoResponseModel';
import { ScriptsAccountGetUsersGetUsersResponseModel } from './scriptsAccountGetUsersGetUsersResponseModel';
import { ScriptsAccountSaveUserSaveUserContactInfoRequestModel } from './scriptsAccountSaveUserSaveUserContactInfoRequestModel';
import { ScriptsAccountSaveUserSaveUserRequestModel } from './scriptsAccountSaveUserSaveUserRequestModel';
import { ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel } from './scriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel';
import { ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel } from './scriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel';
import { ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel } from './scriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel';
import { ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel } from './scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel';
import { ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel } from './scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel';
import { ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel } from './scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel';
import { ScriptsDocumentsV2FillablePdfPdfFileData } from './scriptsDocumentsV2FillablePdfPdfFileData';
import { ScriptsEnrollmentEnrollPatientEnrollmentInputModel } from './scriptsEnrollmentEnrollPatientEnrollmentInputModel';
import { ScriptsMangoV1CardDetailsMedicalCard } from './scriptsMangoV1CardDetailsMedicalCard';
import { ScriptsMangoV1CardDetailsPharmacyCard } from './scriptsMangoV1CardDetailsPharmacyCard';
import { ScriptsMangoV1CardDetailsVirtualDebitCard } from './scriptsMangoV1CardDetailsVirtualDebitCard';
import { ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel } from './scriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel';
import { ScriptsPlpAccountRegisterAccount } from './scriptsPlpAccountRegisterAccount';
import { ScriptsPlpClaimSumbitClaimRequestModel } from './scriptsPlpClaimSumbitClaimRequestModel';
import { ScriptsPlpPatientPatientLookupResponseModel } from './scriptsPlpPatientPatientLookupResponseModel';
import { ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel } from './scriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel';
import { ScriptsSiteAccountV2PatientsPatientAccountModel } from './scriptsSiteAccountV2PatientsPatientAccountModel';
import { ScriptsTempJanssenGECheckPatient } from './scriptsTempJanssenGECheckPatient';
import { SearchAccountResponseModel } from './searchAccountResponseModel';
import { SearchAccountsRequestModel } from './searchAccountsRequestModel';
import { SearchCasesRequestModel } from './searchCasesRequestModel';
import { SearchCasesResponseModel } from './searchCasesResponseModel';
import { SearchPatientsRequestModel } from './searchPatientsRequestModel';
import { SearchWorkflowsRequestModel } from './searchWorkflowsRequestModel';
import { SearchWorkflowsResponseModel } from './searchWorkflowsResponseModel';
import { SecureUpsearchModelPatientPatientUpsearchModel } from './secureUpsearchModelPatientPatientUpsearchModel';
import { SendRequestModel } from './sendRequestModel';
import { Site } from './site';
import { SiteAccountCancelWorkflowDefaultResponse } from './siteAccountCancelWorkflowDefaultResponse';
import { SiteAccountContact } from './siteAccountContact';
import { SiteAccountGetAccountDefaultResponse } from './siteAccountGetAccountDefaultResponse';
import { SiteAccountGetCaseDefaultResponse } from './siteAccountGetCaseDefaultResponse';
import { SiteAccountGetCasesDefaultResponse } from './siteAccountGetCasesDefaultResponse';
import { SiteAccountGetPartyDefaultResponse } from './siteAccountGetPartyDefaultResponse';
import { SiteAccountGetSiteAccountDefaultResponse } from './siteAccountGetSiteAccountDefaultResponse';
import { SiteAccountGetWorkflowsDefaultResponse } from './siteAccountGetWorkflowsDefaultResponse';
import { SiteAccountModel } from './siteAccountModel';
import { SiteAccountRequestModel } from './siteAccountRequestModel';
import { SiteAccountSearchAccountsDefaultResponse } from './siteAccountSearchAccountsDefaultResponse';
import { SiteAccountSearchCasesDefaultResponse } from './siteAccountSearchCasesDefaultResponse';
import { SiteAccountSearchWorkflowsDefaultResponse } from './siteAccountSearchWorkflowsDefaultResponse';
import { SiteAccountSiteRegistrationDefaultResponse } from './siteAccountSiteRegistrationDefaultResponse';
import { SiteAccountV2PatientsSearchPatientsSearchPatientsResponse } from './siteAccountV2PatientsSearchPatientsSearchPatientsResponse';
import { SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse } from './siteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse';
import { SiteDetails } from './siteDetails';
import { SiteEnrollmentModel } from './siteEnrollmentModel';
import { SiteLongResponse } from './siteLongResponse';
import { SiteModel } from './siteModel';
import { SiteModelResponse } from './siteModelResponse';
import { SiteModels } from './siteModels';
import { SitePointOfContactModel } from './sitePointOfContactModel';
import { SiteProcurementMethodModel } from './siteProcurementMethodModel';
import { SiteSearchModelResponse } from './siteSearchModelResponse';
import { SiteSearchRequestModel } from './siteSearchRequestModel';
import { SiteSearchResponseModel } from './siteSearchResponseModel';
import { SiteSharedAddressModel } from './siteSharedAddressModel';
import { SiteSharedAddressUpsearchModel } from './siteSharedAddressUpsearchModel';
import { SiteSharedContactModel } from './siteSharedContactModel';
import { SiteSharedContactModels } from './siteSharedContactModels';
import { SiteSharedContactPreferenceModel } from './siteSharedContactPreferenceModel';
import { SiteSharedContactUpsearchModel } from './siteSharedContactUpsearchModel';
import { SiteSharedEmailAddressModel } from './siteSharedEmailAddressModel';
import { SiteSharedEmailAddressUpsearchModel } from './siteSharedEmailAddressUpsearchModel';
import { SiteSharedExternalIdModel } from './siteSharedExternalIdModel';
import { SiteSharedExternalIdUpsearchModel } from './siteSharedExternalIdUpsearchModel';
import { SiteSharedGlobalIdModel } from './siteSharedGlobalIdModel';
import { SiteSharedGlobalIdUpsearchModel } from './siteSharedGlobalIdUpsearchModel';
import { SiteSharedPhoneModel } from './siteSharedPhoneModel';
import { SiteSharedPhoneUpsearchModel } from './siteSharedPhoneUpsearchModel';
import { SiteSharedWebAddressModel } from './siteSharedWebAddressModel';
import { SiteSharedWebAddressUpsearchModel } from './siteSharedWebAddressUpsearchModel';
import { SiteUpsearchModel } from './siteUpsearchModel';
import { SubmitClaimResultModel } from './submitClaimResultModel';
import { SubmitClaimResultModelResponse } from './submitClaimResultModelResponse';
import { SurveyFullSurveySessionValuesModel } from './surveyFullSurveySessionValuesModel';
import { SurveyIdListRequestModel } from './surveyIdListRequestModel';
import { SurveyQuestionCategoryModel } from './surveyQuestionCategoryModel';
import { SurveyResponseModel } from './surveyResponseModel';
import { SurveySaveQuestionResultModelResponse } from './surveySaveQuestionResultModelResponse';
import { SurveySaveQuestionResultRequestModel } from './surveySaveQuestionResultRequestModel';
import { SurveySaveQuestionResultResponseModel } from './surveySaveQuestionResultResponseModel';
import { SurveySessionPostRequest } from './surveySessionPostRequest';
import { SurveySessionValueModel } from './surveySessionValueModel';
import { SurveySessionValuePostRequest } from './surveySessionValuePostRequest';
import { SurveySessionValueReadModel } from './surveySessionValueReadModel';
import { SurveySessionValueReadModels } from './surveySessionValueReadModels';
import { SurveyStartSessionModelResponse } from './surveyStartSessionModelResponse';
import { SurveyStartSessionRequestModel } from './surveyStartSessionRequestModel';
import { SurveyStartSessionResponseModel } from './surveyStartSessionResponseModel';
import { TempGetNumberOfApplicationsDefaultResponse } from './tempGetNumberOfApplicationsDefaultResponse';
import { TempGetNumberOfApplicationsDefaultResponseData } from './tempGetNumberOfApplicationsDefaultResponseData';
import { TempJanssenGeCheckDefaultResponse } from './tempJanssenGeCheckDefaultResponse';
import { UnsubscribeBySourceNameRequestModel } from './unsubscribeBySourceNameRequestModel';
import { UnsubscribeRequestModel } from './unsubscribeRequestModel';
import { UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel } from './upsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel';
import { UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel } from './upsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel';
import { UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel } from './upsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel';
import { UpsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel } from './upsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel';
import { UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel } from './upsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel';
import { UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel } from './upsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel';
import { UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel } from './upsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel';
import { UpsearchModelPayorPayorUpsearchModel } from './upsearchModelPayorPayorUpsearchModel';
import { UpsearchModelPharmacyPharmacyUpsearchModel } from './upsearchModelPharmacyPharmacyUpsearchModel';
import { UpsearchModelPrescriberPrescriberUpsearchModel } from './upsearchModelPrescriberPrescriberUpsearchModel';
import { UpsearchModelSiteSiteUpsearchModel } from './upsearchModelSiteSiteUpsearchModel';
import { UserRequestModel } from './userRequestModel';
import { WorkflowModel } from './workflowModel';
export const Serializer = new ObjectSerializer({
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'AccountExternalIdType': AccountExternalIdType,
    // @ts-ignore
    'AccountType': AccountType,
    // @ts-ignore
    'AccountStatus': AccountStatus,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'Extauth2ValidateStatus': Extauth2ValidateStatus,
    // @ts-ignore
    'Extauth2ChangePasswordStatus': Extauth2ChangePasswordStatus,
    // @ts-ignore
    'AuthenticateStatus': AuthenticateStatus,
    // @ts-ignore
    'Extauth2ProfileUpdateStatus': Extauth2ProfileUpdateStatus,
    // @ts-ignore
    'AuthenticateStatus': AuthenticateStatus,
    // @ts-ignore
    'CommunicationTypesEnum': CommunicationTypesEnum,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'SystemStatus': SystemStatus,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'CaseExternalIdType': CaseExternalIdType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'SystemStatus': SystemStatus,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'ClaimTypeCode': ClaimTypeCode,
    // @ts-ignore
    'TCSEligibilityStatus': TCSEligibilityStatus,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'DebitCardMapStatus': DebitCardMapStatus,
    // @ts-ignore
    'ProcessorType': ProcessorType,
    // @ts-ignore
    'DebitCardVmcUsageRegion': DebitCardVmcUsageRegion,
    // @ts-ignore
    'DiagnosisType': DiagnosisType,
    // @ts-ignore
    'DiagnosisType': DiagnosisType,
    // @ts-ignore
    'DiagnosisType': DiagnosisType,
    // @ts-ignore
    'DocumentGroupSource': DocumentGroupSource,
    // @ts-ignore
    'TransmissionType': TransmissionType,
    // @ts-ignore
    'DocumentStatus': DocumentStatus,
    // @ts-ignore
    'DocumentGroupStatus': DocumentGroupStatus,
    // @ts-ignore
    'DocumentGroupSource': DocumentGroupSource,
    // @ts-ignore
    'DocumentStatus': DocumentStatus,
    // @ts-ignore
    'DocumentGroupStatus': DocumentGroupStatus,
    // @ts-ignore
    'DocumentStatus': DocumentStatus,
    // @ts-ignore
    'DocumentGroupStatus': DocumentGroupStatus,
    // @ts-ignore
    'DocumentGroupSource': DocumentGroupSource,
    // @ts-ignore
    'EmailErrorCode': EmailErrorCode,
    // @ts-ignore
    'MessageContentType': MessageContentType,
    // @ts-ignore
    'MessageContentType': MessageContentType,
    // @ts-ignore
    'EnrollPatientCaseInitiator': EnrollPatientCaseInitiator,
    // @ts-ignore
    'AlternateCardType': AlternateCardType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    "EnrollmentCreateSiteRequestModel.CommunicationTypesEnum": EnrollmentCreateSiteRequestModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'EnrollmentStatus': EnrollmentStatus,
    // @ts-ignore
    'TCSRelationshipType': TCSRelationshipType,
    // @ts-ignore
    'TCSInsuranceType': TCSInsuranceType,
    // @ts-ignore
    'TCSInsuranceType': TCSInsuranceType,
    // @ts-ignore
    'EnrollmentType': EnrollmentType,
    // @ts-ignore
    'EnrollmentType': EnrollmentType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    'TCSInsuranceType': TCSInsuranceType,
    // @ts-ignore
    'EnrollmentType': EnrollmentType,
    // @ts-ignore
    'TCSEligibilityStatus': TCSEligibilityStatus,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    "EnrollmentPatientUpdateDemographicsModel.CommunicationTypesEnum": EnrollmentPatientUpdateDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'EnrollmentApiPaymentType': EnrollmentApiPaymentType,
    // @ts-ignore
    'EnrollmentStatus': EnrollmentStatus,
    // @ts-ignore
    'EnrollmentType': EnrollmentType,
    // @ts-ignore
    'EnrollmentEligibility': EnrollmentEligibility,
    // @ts-ignore
    'EnrollmentScenario': EnrollmentScenario,
    // @ts-ignore
    'EnrollmentType': EnrollmentType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ExternalIdType': ExternalIdType,
    // @ts-ignore
    'AccountExternalIdType': AccountExternalIdType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'AccountType': AccountType,
    // @ts-ignore
    'AccountStatus': AccountStatus,
    // @ts-ignore
    'AccountType': AccountType,
    // @ts-ignore
    'AccountStatus': AccountStatus,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PharmacyType': PharmacyType,
    // @ts-ignore
    'PharmacySpecialization': PharmacySpecialization,
    // @ts-ignore
    'PharmacyType': PharmacyType,
    // @ts-ignore
    'PharmacySpecialization': PharmacySpecialization,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ExternalIdType': ExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    "HybridEnrollmentDemographicsModel.CommunicationTypesEnum": HybridEnrollmentDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSPaymentType': TCSPaymentType,
    // @ts-ignore
    'AuthenticateStatus': AuthenticateStatus,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'LocationCorrection': LocationCorrection,
    // @ts-ignore
    'Dpv': Dpv,
    // @ts-ignore
    "MedBenEnrollmentDemographicsModel.CommunicationTypesEnum": MedBenEnrollmentDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSPaymentType': TCSPaymentType,
    // @ts-ignore
    'NoteTypeCategory': NoteTypeCategory,
    // @ts-ignore
    'NoteTypeCategory': NoteTypeCategory,
    // @ts-ignore
    'NoteTypeCategory': NoteTypeCategory,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'QueryStringMatch': QueryStringMatch,
    // @ts-ignore
    'QueryStringMatch': QueryStringMatch,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'AccountExternalIdType': AccountExternalIdType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'PlanType': PlanType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'PayorType': PayorType,
    // @ts-ignore
    'PharmacyType': PharmacyType,
    // @ts-ignore
    'PharmacySpecialization': PharmacySpecialization,
    // @ts-ignore
    'PharmacyType': PharmacyType,
    // @ts-ignore
    'PharmacySpecialization': PharmacySpecialization,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'PharmacyType': PharmacyType,
    // @ts-ignore
    'PharmacySpecialization': PharmacySpecialization,
    // @ts-ignore
    'Extauth2ValidateStatus': Extauth2ValidateStatus,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'PrescriberLicenseType': PrescriberLicenseType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'Gender': Gender,
    // @ts-ignore
    'TCSSiteType': TCSSiteType,
    // @ts-ignore
    "SiteEnrollmentModel.SiteCommunicationTypesEnum": SiteEnrollmentModel.SiteCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    "SiteEnrollmentModel.PrescriberCommunicationTypesEnum": SiteEnrollmentModel.PrescriberCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'AddressType': AddressType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'PartyExternalIdType': PartyExternalIdType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactDatePreferenceType': ContactDatePreferenceType,
    // @ts-ignore
    'ContactTimePreferenceType': ContactTimePreferenceType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'ContactInfoPurposeType': ContactInfoPurposeType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'RoleType': RoleType,
    // @ts-ignore
    'TCSDocumentType': TCSDocumentType,
}, {
    "AccountActivateUserDefaultResponse": AccountActivateUserDefaultResponse,
    "AccountAddressModel": AccountAddressModel,
    "AccountAttestationAttributeModel": AccountAttestationAttributeModel,
    "AccountContactModel": AccountContactModel,
    "AccountContactPreferenceModel": AccountContactPreferenceModel,
    "AccountDocumentRelationshipModel": AccountDocumentRelationshipModel,
    "AccountExternalIdModel": AccountExternalIdModel,
    "AccountGetPrescribersDefaultResponse": AccountGetPrescribersDefaultResponse,
    "AccountGetSitesDefaultResponse": AccountGetSitesDefaultResponse,
    "AccountGetTasksDefaultResponse": AccountGetTasksDefaultResponse,
    "AccountGetUsersDefaultResponse": AccountGetUsersDefaultResponse,
    "AccountLinkedPayorModel": AccountLinkedPayorModel,
    "AccountModel": AccountModel,
    "AccountOptionalServiceModel": AccountOptionalServiceModel,
    "AccountOrderRelationModel": AccountOrderRelationModel,
    "AccountPayorRelationModel": AccountPayorRelationModel,
    "AccountPhoneModel": AccountPhoneModel,
    "AccountRelationModel": AccountRelationModel,
    "AccountRemovePrescriberDefaultResponse": AccountRemovePrescriberDefaultResponse,
    "AccountRemoveSiteDefaultResponse": AccountRemoveSiteDefaultResponse,
    "AccountSavePrescriberDefaultResponse": AccountSavePrescriberDefaultResponse,
    "AccountSaveSiteDefaultResponse": AccountSaveSiteDefaultResponse,
    "AccountSaveTaskDefaultResponse": AccountSaveTaskDefaultResponse,
    "AccountSaveUserDefaultResponse": AccountSaveUserDefaultResponse,
    "AccountSaveUserRoleDefaultResponse": AccountSaveUserRoleDefaultResponse,
    "AccountSessionModel": AccountSessionModel,
    "AccountVoicemailOptInModel": AccountVoicemailOptInModel,
    "Address": Address,
    "AdminGetSiteAccountsDefaultResponse": AdminGetSiteAccountsDefaultResponse,
    "AuthenticateUserRequestModel": AuthenticateUserRequestModel,
    "AuthenticationAuthenticateUserDefaultResponse": AuthenticationAuthenticateUserDefaultResponse,
    "AuthenticationChangePasswordDefaultResponse": AuthenticationChangePasswordDefaultResponse,
    "AuthenticationGetCurrentUserDefaultResponse": AuthenticationGetCurrentUserDefaultResponse,
    "AuthenticationIsEmailRegisteredDefaultResponse": AuthenticationIsEmailRegisteredDefaultResponse,
    "AuthenticationIsExistingUserResponse": AuthenticationIsExistingUserResponse,
    "AuthenticationResetPasswordDefaultResponse": AuthenticationResetPasswordDefaultResponse,
    "AuthenticationSaveCurrentUserDefaultResponse": AuthenticationSaveCurrentUserDefaultResponse,
    "AuthenticationTouchResponse": AuthenticationTouchResponse,
    "AuthenticationTouchResponseData": AuthenticationTouchResponseData,
    "AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse": AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse,
    "AuthenticationV2UserCreateStandardUserCreateStandardUserResponse": AuthenticationV2UserCreateStandardUserCreateStandardUserResponse,
    "AuthenticationV2UserDeleteUserIdDeleteUserResponse": AuthenticationV2UserDeleteUserIdDeleteUserResponse,
    "AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse": AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse,
    "AuthenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse": AuthenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse,
    "AuthenticationV2UserUpdateUserIdUpdateUserResponse": AuthenticationV2UserUpdateUserIdUpdateUserResponse,
    "CancelWorkflowRequestModel": CancelWorkflowRequestModel,
    "CardAccumulatorModel": CardAccumulatorModel,
    "CardClaimAccumulatorModel": CardClaimAccumulatorModel,
    "CardClaimModel": CardClaimModel,
    "CardInternalStatusResultModel": CardInternalStatusResultModel,
    "CardMedicationModel": CardMedicationModel,
    "CardMemberNumberStatusResultModel": CardMemberNumberStatusResultModel,
    "CardMemberNumberStatusResultModelResponse": CardMemberNumberStatusResultModelResponse,
    "CardRedemptionListResultModel": CardRedemptionListResultModel,
    "CardTcsRedemptionListRecordModel": CardTcsRedemptionListRecordModel,
    "CaseAddressModel": CaseAddressModel,
    "CaseAllowedCaseStatusModel": CaseAllowedCaseStatusModel,
    "CaseAllowedCaseStatusModels": CaseAllowedCaseStatusModels,
    "CaseAttestationAttributeModel": CaseAttestationAttributeModel,
    "CaseConditionRelationshipModel": CaseConditionRelationshipModel,
    "CaseContactPreferenceModel": CaseContactPreferenceModel,
    "CaseDocumentRelationshipModel": CaseDocumentRelationshipModel,
    "CaseExternalIdModel": CaseExternalIdModel,
    "CaseHomeHealthAgencyRelationshipModel": CaseHomeHealthAgencyRelationshipModel,
    "CaseModel": CaseModel,
    "CaseOrderedRelationshipModel": CaseOrderedRelationshipModel,
    "CasePayorRelationshipModel": CasePayorRelationshipModel,
    "CasePhoneModel": CasePhoneModel,
    "CasePrescriptionRelationshipModel": CasePrescriptionRelationshipModel,
    "CaseProgramCaseTypeModel": CaseProgramCaseTypeModel,
    "CaseProgramCaseTypeModels": CaseProgramCaseTypeModels,
    "CaseRelationshipModel": CaseRelationshipModel,
    "CaseSessionModel": CaseSessionModel,
    "CaseTypeModel": CaseTypeModel,
    "CaseTypeModels": CaseTypeModels,
    "CaseTypeStatusModel": CaseTypeStatusModel,
    "CaseTypeStatusModels": CaseTypeStatusModels,
    "CaseWorkflowCaseModel": CaseWorkflowCaseModel,
    "CaseWorkflowModel": CaseWorkflowModel,
    "ChangePasswordRequestModel": ChangePasswordRequestModel,
    "ClaimAccumulatorModel": ClaimAccumulatorModel,
    "ClaimAccumulatorModels": ClaimAccumulatorModels,
    "ClaimAdjudicationClaimLineItem": ClaimAdjudicationClaimLineItem,
    "ClaimAdjudicationCodeModel": ClaimAdjudicationCodeModel,
    "ClaimAdjudicationMedicalInsurance": ClaimAdjudicationMedicalInsurance,
    "ClaimAdjudicationPatientDetails": ClaimAdjudicationPatientDetails,
    "ClaimAdjudicationPharmacyInsurance": ClaimAdjudicationPharmacyInsurance,
    "ClaimAdjudicationProviderDetails": ClaimAdjudicationProviderDetails,
    "ClaimAdjudicationRequest": ClaimAdjudicationRequest,
    "ClaimAdjudicationResponse": ClaimAdjudicationResponse,
    "ClaimAdjudicationResponseLineItem": ClaimAdjudicationResponseLineItem,
    "ClaimConditionModel": ClaimConditionModel,
    "ClaimDetailsResponseModel": ClaimDetailsResponseModel,
    "ClaimExternalReferenceModel": ClaimExternalReferenceModel,
    "ClaimFileOutputModel": ClaimFileOutputModel,
    "ClaimKeyValuePairLongString": ClaimKeyValuePairLongString,
    "ClaimLookupModel": ClaimLookupModel,
    "ClaimMedicalClaimModel": ClaimMedicalClaimModel,
    "ClaimMedicalClaimSearchModel": ClaimMedicalClaimSearchModel,
    "ClaimPayorModel": ClaimPayorModel,
    "ClaimPharmacyClaimModel": ClaimPharmacyClaimModel,
    "ClaimProviderLocationModel": ClaimProviderLocationModel,
    "ClaimProviderModel": ClaimProviderModel,
    "ClaimSearchModel": ClaimSearchModel,
    "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest": ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest,
    "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse": ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse,
    "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest": ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest,
    "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse": ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse,
    "Contact": Contact,
    "CouponDocumentsSubmitDocumentsSubmitDocumentsRequest": CouponDocumentsSubmitDocumentsSubmitDocumentsRequest,
    "CouponDocumentsSubmitDocumentsSubmitDocumentsResponse": CouponDocumentsSubmitDocumentsSubmitDocumentsResponse,
    "CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse": CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse,
    "CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse": CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse,
    "CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse": CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse,
    "CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse": CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse,
    "CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse": CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse,
    "CouponGetEnrollmentDetailsDefaultResponse": CouponGetEnrollmentDetailsDefaultResponse,
    "CouponGetEnrollmentDetailsDefaultResponseData": CouponGetEnrollmentDetailsDefaultResponseData,
    "CouponMemberMemberNumberStatusMemberNumberStatusRequest": CouponMemberMemberNumberStatusMemberNumberStatusRequest,
    "CouponMemberMemberNumberStatusMemberNumberStatusResponse": CouponMemberMemberNumberStatusMemberNumberStatusResponse,
    "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest": CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest,
    "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse": CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse,
    "CouponMemberReplaceCardReplaceCardRequest": CouponMemberReplaceCardReplaceCardRequest,
    "CouponMemberReplaceCardReplaceCardResponse": CouponMemberReplaceCardReplaceCardResponse,
    "CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse": CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse,
    "CouponPatientPatientSearchPatientSearchResponse": CouponPatientPatientSearchPatientSearchResponse,
    "CouponRedemptionListListResponse": CouponRedemptionListListResponse,
    "CouponSubmitDocumentsRequestModel": CouponSubmitDocumentsRequestModel,
    "DeactivateEnrollmentRequest": DeactivateEnrollmentRequest,
    "DebitCardGetDebitCardDetailDefaultResponse": DebitCardGetDebitCardDetailDefaultResponse,
    "DebitCardGetLashPatientDebitCardLast4DefaultResponse": DebitCardGetLashPatientDebitCardLast4DefaultResponse,
    "DebitCardInfoResponseModel": DebitCardInfoResponseModel,
    "DiagnosisModel": DiagnosisModel,
    "DiagnosisModelResponse": DiagnosisModelResponse,
    "DiagnosisModels": DiagnosisModels,
    "DiagnosisSearchModelResponse": DiagnosisSearchModelResponse,
    "DiagnosisSearchRequestModel": DiagnosisSearchRequestModel,
    "DiagnosisSearchResponseModel": DiagnosisSearchResponseModel,
    "DocumentCreateModel": DocumentCreateModel,
    "DocumentCreateResponseModel": DocumentCreateResponseModel,
    "DocumentLinkModel": DocumentLinkModel,
    "DocumentLongResponse": DocumentLongResponse,
    "DocumentModel": DocumentModel,
    "DocumentModelResponse": DocumentModelResponse,
    "DocumentParentLinkModel": DocumentParentLinkModel,
    "DocumentPdfDocumentModel": DocumentPdfDocumentModel,
    "DocumentPdfFileModel": DocumentPdfFileModel,
    "DocumentPdfFileStyleModel": DocumentPdfFileStyleModel,
    "DocumentsV1DocumentUploadUploadResponse": DocumentsV1DocumentUploadUploadResponse,
    "DocumentsV1GeneratePdfFromHtmlSaveSaveResponse": DocumentsV1GeneratePdfFromHtmlSaveSaveResponse,
    "DocumentsV1GeneratePdfFromTemplateSaveSaveResponse": DocumentsV1GeneratePdfFromTemplateSaveSaveResponse,
    "DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse": DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse,
    "EmailEmailContact": EmailEmailContact,
    "EmailIsUnsubscribedDefaultResponse": EmailIsUnsubscribedDefaultResponse,
    "EmailReturnResult": EmailReturnResult,
    "EmailReturnResultResponse": EmailReturnResultResponse,
    "EmailSendDefaultResponse": EmailSendDefaultResponse,
    "EmailSendEmailSingle": EmailSendEmailSingle,
    "EmailUnsubscribeDefaultResponse": EmailUnsubscribeDefaultResponse,
    "EnrollPatientRequestModel": EnrollPatientRequestModel,
    "EnrollPatientResponse": EnrollPatientResponse,
    "EnrollmentAccumulatorModel": EnrollmentAccumulatorModel,
    "EnrollmentAlternateCardId": EnrollmentAlternateCardId,
    "EnrollmentCaseDocumentRelationshipModel": EnrollmentCaseDocumentRelationshipModel,
    "EnrollmentCaseOrderedRelationshipModel": EnrollmentCaseOrderedRelationshipModel,
    "EnrollmentCasePrescriptionRelationshipModel": EnrollmentCasePrescriptionRelationshipModel,
    "EnrollmentCaseRelationshipModel": EnrollmentCaseRelationshipModel,
    "EnrollmentCaseRelationshipsModel": EnrollmentCaseRelationshipsModel,
    "EnrollmentCaseRoleTypeRelationshipModel": EnrollmentCaseRoleTypeRelationshipModel,
    "EnrollmentCheckMemberNumberDefaultResponse": EnrollmentCheckMemberNumberDefaultResponse,
    "EnrollmentClientIdentifiersModel": EnrollmentClientIdentifiersModel,
    "EnrollmentCommTypeUpdateRequestModel": EnrollmentCommTypeUpdateRequestModel,
    "EnrollmentConditionTypeModel": EnrollmentConditionTypeModel,
    "EnrollmentCreatePrescriberRequestModel": EnrollmentCreatePrescriberRequestModel,
    "EnrollmentCreatePrescriberResultModel": EnrollmentCreatePrescriberResultModel,
    "EnrollmentCreatePrescriberResultModelResponse": EnrollmentCreatePrescriberResultModelResponse,
    "EnrollmentCreateSiteRequestModel": EnrollmentCreateSiteRequestModel,
    "EnrollmentCreateSiteResultModel": EnrollmentCreateSiteResultModel,
    "EnrollmentCreateSiteResultModelResponse": EnrollmentCreateSiteResultModelResponse,
    "EnrollmentDeactivateResponse": EnrollmentDeactivateResponse,
    "EnrollmentDemographicsModel": EnrollmentDemographicsModel,
    "EnrollmentDocumentModel": EnrollmentDocumentModel,
    "EnrollmentEligibilityModel": EnrollmentEligibilityModel,
    "EnrollmentEnrollPatientDefaultResponse": EnrollmentEnrollPatientDefaultResponse,
    "EnrollmentGetBestEnrollmentDefaultResponse": EnrollmentGetBestEnrollmentDefaultResponse,
    "EnrollmentGetBestEnrollmentsV2DefaultResponse": EnrollmentGetBestEnrollmentsV2DefaultResponse,
    "EnrollmentGuardianInfoModel": EnrollmentGuardianInfoModel,
    "EnrollmentHistoryModel": EnrollmentHistoryModel,
    "EnrollmentHybridPatientSearchResultModel": EnrollmentHybridPatientSearchResultModel,
    "EnrollmentInsVerRequestModel": EnrollmentInsVerRequestModel,
    "EnrollmentInsuranceVerificationModel": EnrollmentInsuranceVerificationModel,
    "EnrollmentIsValidMemberNumberModel": EnrollmentIsValidMemberNumberModel,
    "EnrollmentIsValidMemberNumberModelResponse": EnrollmentIsValidMemberNumberModelResponse,
    "EnrollmentIsValidMemberNumberRequestModel": EnrollmentIsValidMemberNumberRequestModel,
    "EnrollmentMedBenClientIdentifiersModel": EnrollmentMedBenClientIdentifiersModel,
    "EnrollmentMedBenInsuranceVerificationModel": EnrollmentMedBenInsuranceVerificationModel,
    "EnrollmentMedicationModel": EnrollmentMedicationModel,
    "EnrollmentMemberNumberModel": EnrollmentMemberNumberModel,
    "EnrollmentModel": EnrollmentModel,
    "EnrollmentPatientLookupRequestModel": EnrollmentPatientLookupRequestModel,
    "EnrollmentPatientLookupResultModel": EnrollmentPatientLookupResultModel,
    "EnrollmentPatientSearchRecordModel": EnrollmentPatientSearchRecordModel,
    "EnrollmentPatientSearchResultModel": EnrollmentPatientSearchResultModel,
    "EnrollmentPatientUpdateDemographicsModel": EnrollmentPatientUpdateDemographicsModel,
    "EnrollmentPatientUpdateRequestModel": EnrollmentPatientUpdateRequestModel,
    "EnrollmentPhoneNumberModel": EnrollmentPhoneNumberModel,
    "EnrollmentRequest": EnrollmentRequest,
    "EnrollmentRequestModel": EnrollmentRequestModel,
    "EnrollmentResponse": EnrollmentResponse,
    "EnrollmentResponseModel": EnrollmentResponseModel,
    "EnrollmentResultModel": EnrollmentResultModel,
    "EnrollmentResultModelResponse": EnrollmentResultModelResponse,
    "EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel": EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel,
    "EnrollmentSurveyQuestionModel": EnrollmentSurveyQuestionModel,
    "EnrollmentUpdateRequestModel": EnrollmentUpdateRequestModel,
    "EnrollmentV2ConditionTypeModel": EnrollmentV2ConditionTypeModel,
    "EnrollmentV2EligibilityModel": EnrollmentV2EligibilityModel,
    "EnrollmentV2EnrollmentModel": EnrollmentV2EnrollmentModel,
    "EnrollmentV2MemberNumberModel": EnrollmentV2MemberNumberModel,
    "EnrollmentV2ProcessingBenefitModel": EnrollmentV2ProcessingBenefitModel,
    "EnrollmentV2ProcessingOutcomeModel": EnrollmentV2ProcessingOutcomeModel,
    "EnrollmentV2ProcessingResultModel": EnrollmentV2ProcessingResultModel,
    "EnrollmentV2RulesAssignMemberNumberResultModel": EnrollmentV2RulesAssignMemberNumberResultModel,
    "EnrollmentV2RulesMemberNumberBucketResult": EnrollmentV2RulesMemberNumberBucketResult,
    "EnrollmentVerifySurveyEntryRequestModel": EnrollmentVerifySurveyEntryRequestModel,
    "EnrollmentVerifySurveyEntryResultModel": EnrollmentVerifySurveyEntryResultModel,
    "EnrollmentVerifySurveyEntryResultModelResponse": EnrollmentVerifySurveyEntryResultModelResponse,
    "EnterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel": EnterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel": EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel": EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel": EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel": EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel": EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel": EnterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountRelationModel": EnterpriseCoordinatorAccountServiceModelsAccountRelationModel,
    "EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel": EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    "EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel": EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel,
    "EnterpriseCoordinatorAccountUpsearchModelResponse": EnterpriseCoordinatorAccountUpsearchModelResponse,
    "EnterpriseCoordinatorAccountUpsearchRequestModel": EnterpriseCoordinatorAccountUpsearchRequestModel,
    "EnterpriseCoordinatorAccountUpsearchResponseModel": EnterpriseCoordinatorAccountUpsearchResponseModel,
    "EnterpriseCoordinatorCaseDocumentRelationshipModel": EnterpriseCoordinatorCaseDocumentRelationshipModel,
    "EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel": EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel,
    "EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel": EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    "EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel": EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel,
    "EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel": EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    "EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel": EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel,
    "EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel": EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel,
    "EnterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel": EnterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel,
    "EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel": EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    "EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel": EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel,
    "EnterpriseCoordinatorSharedAddressUpsearchModel": EnterpriseCoordinatorSharedAddressUpsearchModel,
    "EnterpriseCoordinatorSharedContactUpsearchModel": EnterpriseCoordinatorSharedContactUpsearchModel,
    "EnterpriseCoordinatorSharedEmailAddressUpsearchModel": EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    "EnterpriseCoordinatorSharedExternalIdUpsearchModel": EnterpriseCoordinatorSharedExternalIdUpsearchModel,
    "EnterpriseCoordinatorSharedGlobalIdUpsearchModel": EnterpriseCoordinatorSharedGlobalIdUpsearchModel,
    "EnterpriseCoordinatorSharedPhoneUpsearchModel": EnterpriseCoordinatorSharedPhoneUpsearchModel,
    "EnterpriseCoordinatorSharedWebAddressUpsearchModel": EnterpriseCoordinatorSharedWebAddressUpsearchModel,
    "EnterpriseCoordinatorSiteAccountUpsearchModelResponse": EnterpriseCoordinatorSiteAccountUpsearchModelResponse,
    "EnterpriseCoordinatorSiteAccountUpsearchRequestModel": EnterpriseCoordinatorSiteAccountUpsearchRequestModel,
    "EnterpriseCoordinatorSiteAccountUpsearchResponseModel": EnterpriseCoordinatorSiteAccountUpsearchResponseModel,
    "EnterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel": EnterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel,
    "EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel": EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel,
    "EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel": EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    "FullSurveySessionByIdsPostRequest": FullSurveySessionByIdsPostRequest,
    "FullSurveySessionPostRequest": FullSurveySessionPostRequest,
    "GatewayError": GatewayError,
    "GenerateAndSavePdfFromHtmlRequest": GenerateAndSavePdfFromHtmlRequest,
    "GenerateAndSavePdfFromTemplateRequest": GenerateAndSavePdfFromTemplateRequest,
    "GeneratePdfFromHtmlRequest": GeneratePdfFromHtmlRequest,
    "GeneratePdfFromTemplateRequest": GeneratePdfFromTemplateRequest,
    "GeneratePdfFromTemplateRequestContent": GeneratePdfFromTemplateRequestContent,
    "GeneratePdfFromTemplateRequestContentPoint": GeneratePdfFromTemplateRequestContentPoint,
    "GetAccountRequestModel": GetAccountRequestModel,
    "GetAccountResponseModel": GetAccountResponseModel,
    "GetBestEnrollmentRequest": GetBestEnrollmentRequest,
    "GetBestEnrollmentResponse": GetBestEnrollmentResponse,
    "GetBestEnrollmentV2RequestModel": GetBestEnrollmentV2RequestModel,
    "GetCasePayorResponseModel": GetCasePayorResponseModel,
    "GetCasePayorResponseModelBenefitData": GetCasePayorResponseModelBenefitData,
    "GetCasePharmacyResponseModel": GetCasePharmacyResponseModel,
    "GetCaseRequestModel": GetCaseRequestModel,
    "GetCaseResponseModel": GetCaseResponseModel,
    "GetCaseSiteResponseModel": GetCaseSiteResponseModel,
    "GetCaseSurveyResponseModel": GetCaseSurveyResponseModel,
    "GetCasesRequestModel": GetCasesRequestModel,
    "GetDebitCardDetailRequestModel": GetDebitCardDetailRequestModel,
    "GetEnrollmentDetailsRequestModel": GetEnrollmentDetailsRequestModel,
    "GetLashPatientDebitCardLast4RequestModel": GetLashPatientDebitCardLast4RequestModel,
    "GetPatientAccountResponseModel": GetPatientAccountResponseModel,
    "GetPatientRequestModel": GetPatientRequestModel,
    "GetSiteAccountsRequestModel": GetSiteAccountsRequestModel,
    "GetSiteAccountsResponseModel": GetSiteAccountsResponseModel,
    "GetWorkflowsRequestModel": GetWorkflowsRequestModel,
    "HcpIntakeRequestModel": HcpIntakeRequestModel,
    "HcpIntakeResponseModel": HcpIntakeResponseModel,
    "HubV1GetAccountDefaultResponse": HubV1GetAccountDefaultResponse,
    "HubV1GetPatientDefaultResponse": HubV1GetPatientDefaultResponse,
    "HubV1SavePatientDefaultResponse": HubV1SavePatientDefaultResponse,
    "HubV1SavePatientDefaultResponseData": HubV1SavePatientDefaultResponseData,
    "HubV1SearchAccountsDefaultResponse": HubV1SearchAccountsDefaultResponse,
    "HubV1SearchPatientsDefaultResponse": HubV1SearchPatientsDefaultResponse,
    "HybridEnrollmentDemographicsModel": HybridEnrollmentDemographicsModel,
    "HybridEnrollmentHistoryModel": HybridEnrollmentHistoryModel,
    "HybridEnrollmentRequestModel": HybridEnrollmentRequestModel,
    "HybridEnrollmentResultModel": HybridEnrollmentResultModel,
    "HybridEnrollmentResultModelResponse": HybridEnrollmentResultModelResponse,
    "IActivateUserRequestModel": IActivateUserRequestModel,
    "IAuthenticateAndCreateSessionRequest": IAuthenticateAndCreateSessionRequest,
    "IAuthenticationData": IAuthenticationData,
    "IAuthenticationResponseModel": IAuthenticationResponseModel,
    "ICreateSessionRequest": ICreateSessionRequest,
    "IExistingUserRequest": IExistingUserRequest,
    "IGetTasksRequestModel": IGetTasksRequestModel,
    "IIsPatientRegisteredRequestModel": IIsPatientRegisteredRequestModel,
    "IPatientRegistrationData": IPatientRegistrationData,
    "IPatientRegistrationRequestModel": IPatientRegistrationRequestModel,
    "ISaveUserRoleRequestModel": ISaveUserRoleRequestModel,
    "ISiteRegistrationData": ISiteRegistrationData,
    "ISiteRegistrationRequestModel": ISiteRegistrationRequestModel,
    "ITouchSessionRequest": ITouchSessionRequest,
    "InlineObject": InlineObject,
    "IntakeHcpIntakeDefaultResponse": IntakeHcpIntakeDefaultResponse,
    "IntakeIsHcpIntakeAllowedDefaultResponse": IntakeIsHcpIntakeAllowedDefaultResponse,
    "IntakePatientIntakeDefaultResponse": IntakePatientIntakeDefaultResponse,
    "IntakePatientIntakeDefaultResponseData": IntakePatientIntakeDefaultResponseData,
    "IsEmailRegisteredRequestModel": IsEmailRegisteredRequestModel,
    "IsHcpIntakeAllowedRequestModel": IsHcpIntakeAllowedRequestModel,
    "IsHcpIntakeAllowedRequestModelGender": IsHcpIntakeAllowedRequestModelGender,
    "IsHcpIntakeAllowedResponseModel": IsHcpIntakeAllowedResponseModel,
    "IsUnsubscribedRequestModel": IsUnsubscribedRequestModel,
    "JanssenGECheckRequestModel": JanssenGECheckRequestModel,
    "JanssenGECheckResponseModel": JanssenGECheckResponseModel,
    "LocationAddressCorrectionModel": LocationAddressCorrectionModel,
    "LocationAddressModel": LocationAddressModel,
    "LocationCityModel": LocationCityModel,
    "LocationCityModels": LocationCityModels,
    "LocationSharedStateModel": LocationSharedStateModel,
    "LocationSharedStateModels": LocationSharedStateModels,
    "LocationValidAddressModel": LocationValidAddressModel,
    "LocationValidAddressModelResponse": LocationValidAddressModelResponse,
    "LocationValidAddressResponseModel": LocationValidAddressResponseModel,
    "LongDocumentDocumentCreateModelResponse": LongDocumentDocumentCreateModelResponse,
    "MangoCardDetailsRequest": MangoCardDetailsRequest,
    "MangoHubAddress": MangoHubAddress,
    "MangoHubGetPatientAccountSummary": MangoHubGetPatientAccountSummary,
    "MangoHubGetPatientInfo": MangoHubGetPatientInfo,
    "MangoHubGetPatientSummaryDetails": MangoHubGetPatientSummaryDetails,
    "MangoHubGetPatientSummaryDiagnosis": MangoHubGetPatientSummaryDiagnosis,
    "MangoHubGetPatientSummaryMedicalPayor": MangoHubGetPatientSummaryMedicalPayor,
    "MangoHubGetPatientSummaryPharmacy": MangoHubGetPatientSummaryPharmacy,
    "MangoHubGetPatientSummaryPharmacyPayor": MangoHubGetPatientSummaryPharmacyPayor,
    "MangoHubGetPatientSummaryPrescriber": MangoHubGetPatientSummaryPrescriber,
    "MangoHubGetPatientSummaryPrescription": MangoHubGetPatientSummaryPrescription,
    "MangoHubGetPatientWelcomeSummaryResponse": MangoHubGetPatientWelcomeSummaryResponse,
    "MangoHubGivePatientConsentResponse": MangoHubGivePatientConsentResponse,
    "MangoHubPhone": MangoHubPhone,
    "MangoHubRevokePatientConsentResponse": MangoHubRevokePatientConsentResponse,
    "MangoHubSelectedService": MangoHubSelectedService,
    "MangoHubVerifyPatientRequest": MangoHubVerifyPatientRequest,
    "MangoHubVerifyPatientResponse": MangoHubVerifyPatientResponse,
    "MangoV1CardDetailsGetCardDetailsGetCardDetailsResponse": MangoV1CardDetailsGetCardDetailsGetCardDetailsResponse,
    "MedBenEnrollmentDemographicsModel": MedBenEnrollmentDemographicsModel,
    "MedBenEnrollmentUpdateRequestModel": MedBenEnrollmentUpdateRequestModel,
    "MedicalBenefitRequest": MedicalBenefitRequest,
    "MedicalClaimSearchResponseModel": MedicalClaimSearchResponseModel,
    "MedicalPayor": MedicalPayor,
    "MemberNumberDetails": MemberNumberDetails,
    "NoteConditionRelationshipModel": NoteConditionRelationshipModel,
    "NoteTaskCreateModel": NoteTaskCreateModel,
    "NoteTaskModel": NoteTaskModel,
    "NoteTaskModelResponse": NoteTaskModelResponse,
    "NoteTaskModels": NoteTaskModels,
    "NoteTypeModel": NoteTypeModel,
    "NoteTypeModels": NoteTypeModels,
    "Patient": Patient,
    "PatientAccountGetCaseDefaultResponse": PatientAccountGetCaseDefaultResponse,
    "PatientAccountGetPatientAccountDefaultResponse": PatientAccountGetPatientAccountDefaultResponse,
    "PatientAccountGetPatientActiveEnrollmentsDefaultResponse": PatientAccountGetPatientActiveEnrollmentsDefaultResponse,
    "PatientAccountIsPatientRegisteredDefaultResponse": PatientAccountIsPatientRegisteredDefaultResponse,
    "PatientAccountModel": PatientAccountModel,
    "PatientAccountPatientRegistrationDefaultResponse": PatientAccountPatientRegistrationDefaultResponse,
    "PatientIntakeRequestModel": PatientIntakeRequestModel,
    "PatientModel": PatientModel,
    "PatientModelResponse": PatientModelResponse,
    "PatientResponseModel": PatientResponseModel,
    "PatientSaveModel": PatientSaveModel,
    "PatientSearchModel": PatientSearchModel,
    "PatientSearchModelResponse": PatientSearchModelResponse,
    "PatientSearchRequestModel": PatientSearchRequestModel,
    "PatientSearchResponseModel": PatientSearchResponseModel,
    "PatientSharedAddressModel": PatientSharedAddressModel,
    "PatientSharedAddressUpsearchModel": PatientSharedAddressUpsearchModel,
    "PatientSharedEmailAddressModel": PatientSharedEmailAddressModel,
    "PatientSharedEmailAddressUpsearchModel": PatientSharedEmailAddressUpsearchModel,
    "PatientSharedPhoneModel": PatientSharedPhoneModel,
    "PatientSharedPhoneUpsearchModel": PatientSharedPhoneUpsearchModel,
    "PatientTCEntLib2SecuritySecureModelsSecureInt64Response": PatientTCEntLib2SecuritySecureModelsSecureInt64Response,
    "PatientUpsearchModel": PatientUpsearchModel,
    "PatientsSearchPatientsRequestModel": PatientsSearchPatientsRequestModel,
    "PayorAccountMedicalBenefitModel": PayorAccountMedicalBenefitModel,
    "PayorAccountMedicalBenefitModelResponse": PayorAccountMedicalBenefitModelResponse,
    "PayorAccountMedicalBenefitModels": PayorAccountMedicalBenefitModels,
    "PayorAccountPharmacyBenefitModel": PayorAccountPharmacyBenefitModel,
    "PayorAccountPharmacyBenefitModelResponse": PayorAccountPharmacyBenefitModelResponse,
    "PayorAccountPharmacyBenefitModels": PayorAccountPharmacyBenefitModels,
    "PayorCoverageAreaModel": PayorCoverageAreaModel,
    "PayorCoverageEligibilityRequestModel": PayorCoverageEligibilityRequestModel,
    "PayorLongResponse": PayorLongResponse,
    "PayorModel": PayorModel,
    "PayorModelResponse": PayorModelResponse,
    "PayorPlanListRequestModel": PayorPlanListRequestModel,
    "PayorPlanModel": PayorPlanModel,
    "PayorPlanModels": PayorPlanModels,
    "PayorResponseModel": PayorResponseModel,
    "PayorRoleTypeModel": PayorRoleTypeModel,
    "PayorRoleTypeModels": PayorRoleTypeModels,
    "PayorSaveModel": PayorSaveModel,
    "PayorSearchModel": PayorSearchModel,
    "PayorSearchModelResponse": PayorSearchModelResponse,
    "PayorSearchResponseModel": PayorSearchResponseModel,
    "PayorSharedAddressModel": PayorSharedAddressModel,
    "PayorSharedAddressUpsearchModel": PayorSharedAddressUpsearchModel,
    "PayorSharedContactUpsearchModel": PayorSharedContactUpsearchModel,
    "PayorSharedEmailAddressModel": PayorSharedEmailAddressModel,
    "PayorSharedEmailAddressUpsearchModel": PayorSharedEmailAddressUpsearchModel,
    "PayorSharedGlobalIdModel": PayorSharedGlobalIdModel,
    "PayorSharedPhoneModel": PayorSharedPhoneModel,
    "PayorSharedPhoneUpsearchModel": PayorSharedPhoneUpsearchModel,
    "PayorSharedWebAddressModel": PayorSharedWebAddressModel,
    "PayorSharedWebAddressUpsearchModel": PayorSharedWebAddressUpsearchModel,
    "PayorUpsearchModel": PayorUpsearchModel,
    "Pharmacy": Pharmacy,
    "PharmacyClaimSearchResponseModel": PharmacyClaimSearchResponseModel,
    "PharmacyLongResponse": PharmacyLongResponse,
    "PharmacyModel": PharmacyModel,
    "PharmacyModelResponse": PharmacyModelResponse,
    "PharmacyPayor": PharmacyPayor,
    "PharmacyPointOfContactModel": PharmacyPointOfContactModel,
    "PharmacySearchModel": PharmacySearchModel,
    "PharmacySearchModelResponse": PharmacySearchModelResponse,
    "PharmacySearchResponseModel": PharmacySearchResponseModel,
    "PharmacySharedAddressModel": PharmacySharedAddressModel,
    "PharmacySharedAddressUpsearchModel": PharmacySharedAddressUpsearchModel,
    "PharmacySharedContactUpsearchModel": PharmacySharedContactUpsearchModel,
    "PharmacySharedEmailAddressModel": PharmacySharedEmailAddressModel,
    "PharmacySharedEmailAddressUpsearchModel": PharmacySharedEmailAddressUpsearchModel,
    "PharmacySharedPhoneModel": PharmacySharedPhoneModel,
    "PharmacySharedPhoneUpsearchModel": PharmacySharedPhoneUpsearchModel,
    "PharmacySharedWebAddressModel": PharmacySharedWebAddressModel,
    "PharmacySharedWebAddressUpsearchModel": PharmacySharedWebAddressUpsearchModel,
    "PharmacyUpsearchModel": PharmacyUpsearchModel,
    "PlpAccountRegisterRegisterResponse": PlpAccountRegisterRegisterResponse,
    "PlpPatientGetEnrollmentsGetEnrollmentsResponse": PlpPatientGetEnrollmentsGetEnrollmentsResponse,
    "PlpPatientPatientLookupPatientLookupResponse": PlpPatientPatientLookupPatientLookupResponse,
    "Prescriber": Prescriber,
    "PrescriberLicenseModel": PrescriberLicenseModel,
    "PrescriberLicenseUpsearchModel": PrescriberLicenseUpsearchModel,
    "PrescriberListRequestModel": PrescriberListRequestModel,
    "PrescriberLongResponse": PrescriberLongResponse,
    "PrescriberModel": PrescriberModel,
    "PrescriberModelResponse": PrescriberModelResponse,
    "PrescriberModels": PrescriberModels,
    "PrescriberSearchModelResponse": PrescriberSearchModelResponse,
    "PrescriberSearchRequestModel": PrescriberSearchRequestModel,
    "PrescriberSearchResponseModel": PrescriberSearchResponseModel,
    "PrescriberSharedAddressModel": PrescriberSharedAddressModel,
    "PrescriberSharedAddressUpsearchModel": PrescriberSharedAddressUpsearchModel,
    "PrescriberSharedEmailAddressModel": PrescriberSharedEmailAddressModel,
    "PrescriberSharedEmailAddressUpsearchModel": PrescriberSharedEmailAddressUpsearchModel,
    "PrescriberSharedExternalIdModel": PrescriberSharedExternalIdModel,
    "PrescriberSharedExternalIdUpsearchModel": PrescriberSharedExternalIdUpsearchModel,
    "PrescriberSharedGlobalIdModel": PrescriberSharedGlobalIdModel,
    "PrescriberSharedPhoneModel": PrescriberSharedPhoneModel,
    "PrescriberSharedPhoneUpsearchModel": PrescriberSharedPhoneUpsearchModel,
    "PrescriberSiteListPostRequest": PrescriberSiteListPostRequest,
    "PrescriberSiteSearchPostRequest": PrescriberSiteSearchPostRequest,
    "PrescriberUpsearchModel": PrescriberUpsearchModel,
    "PrescriptionExternalIdModel": PrescriptionExternalIdModel,
    "PrescriptionModel": PrescriptionModel,
    "PrescriptionSignatureModel": PrescriptionSignatureModel,
    "ProgramModel": ProgramModel,
    "ProgramModelResponse": ProgramModelResponse,
    "ProgramModels": ProgramModels,
    "RedemptionListRequestModel": RedemptionListRequestModel,
    "RemovePrescriberRequestModel": RemovePrescriberRequestModel,
    "RemoveSiteRequestModel": RemoveSiteRequestModel,
    "ReplaceCardResultModel": ReplaceCardResultModel,
    "ResetPasswordRequestModel": ResetPasswordRequestModel,
    "SavePatientRequestModel": SavePatientRequestModel,
    "ScriptsAccountGetUsersGetUsersContactInfoResponseModel": ScriptsAccountGetUsersGetUsersContactInfoResponseModel,
    "ScriptsAccountGetUsersGetUsersResponseModel": ScriptsAccountGetUsersGetUsersResponseModel,
    "ScriptsAccountSaveUserSaveUserContactInfoRequestModel": ScriptsAccountSaveUserSaveUserContactInfoRequestModel,
    "ScriptsAccountSaveUserSaveUserRequestModel": ScriptsAccountSaveUserSaveUserRequestModel,
    "ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel": ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel,
    "ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel": ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel,
    "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel": ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel,
    "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel": ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel,
    "ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel": ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel,
    "ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel": ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel,
    "ScriptsDocumentsV2FillablePdfPdfFileData": ScriptsDocumentsV2FillablePdfPdfFileData,
    "ScriptsEnrollmentEnrollPatientEnrollmentInputModel": ScriptsEnrollmentEnrollPatientEnrollmentInputModel,
    "ScriptsMangoV1CardDetailsMedicalCard": ScriptsMangoV1CardDetailsMedicalCard,
    "ScriptsMangoV1CardDetailsPharmacyCard": ScriptsMangoV1CardDetailsPharmacyCard,
    "ScriptsMangoV1CardDetailsVirtualDebitCard": ScriptsMangoV1CardDetailsVirtualDebitCard,
    "ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel": ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel,
    "ScriptsPlpAccountRegisterAccount": ScriptsPlpAccountRegisterAccount,
    "ScriptsPlpClaimSumbitClaimRequestModel": ScriptsPlpClaimSumbitClaimRequestModel,
    "ScriptsPlpPatientPatientLookupResponseModel": ScriptsPlpPatientPatientLookupResponseModel,
    "ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel": ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel,
    "ScriptsSiteAccountV2PatientsPatientAccountModel": ScriptsSiteAccountV2PatientsPatientAccountModel,
    "ScriptsTempJanssenGECheckPatient": ScriptsTempJanssenGECheckPatient,
    "SearchAccountResponseModel": SearchAccountResponseModel,
    "SearchAccountsRequestModel": SearchAccountsRequestModel,
    "SearchCasesRequestModel": SearchCasesRequestModel,
    "SearchCasesResponseModel": SearchCasesResponseModel,
    "SearchPatientsRequestModel": SearchPatientsRequestModel,
    "SearchWorkflowsRequestModel": SearchWorkflowsRequestModel,
    "SearchWorkflowsResponseModel": SearchWorkflowsResponseModel,
    "SecureUpsearchModelPatientPatientUpsearchModel": SecureUpsearchModelPatientPatientUpsearchModel,
    "SendRequestModel": SendRequestModel,
    "Site": Site,
    "SiteAccountCancelWorkflowDefaultResponse": SiteAccountCancelWorkflowDefaultResponse,
    "SiteAccountContact": SiteAccountContact,
    "SiteAccountGetAccountDefaultResponse": SiteAccountGetAccountDefaultResponse,
    "SiteAccountGetCaseDefaultResponse": SiteAccountGetCaseDefaultResponse,
    "SiteAccountGetCasesDefaultResponse": SiteAccountGetCasesDefaultResponse,
    "SiteAccountGetPartyDefaultResponse": SiteAccountGetPartyDefaultResponse,
    "SiteAccountGetSiteAccountDefaultResponse": SiteAccountGetSiteAccountDefaultResponse,
    "SiteAccountGetWorkflowsDefaultResponse": SiteAccountGetWorkflowsDefaultResponse,
    "SiteAccountModel": SiteAccountModel,
    "SiteAccountRequestModel": SiteAccountRequestModel,
    "SiteAccountSearchAccountsDefaultResponse": SiteAccountSearchAccountsDefaultResponse,
    "SiteAccountSearchCasesDefaultResponse": SiteAccountSearchCasesDefaultResponse,
    "SiteAccountSearchWorkflowsDefaultResponse": SiteAccountSearchWorkflowsDefaultResponse,
    "SiteAccountSiteRegistrationDefaultResponse": SiteAccountSiteRegistrationDefaultResponse,
    "SiteAccountV2PatientsSearchPatientsSearchPatientsResponse": SiteAccountV2PatientsSearchPatientsSearchPatientsResponse,
    "SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse": SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse,
    "SiteDetails": SiteDetails,
    "SiteEnrollmentModel": SiteEnrollmentModel,
    "SiteLongResponse": SiteLongResponse,
    "SiteModel": SiteModel,
    "SiteModelResponse": SiteModelResponse,
    "SiteModels": SiteModels,
    "SitePointOfContactModel": SitePointOfContactModel,
    "SiteProcurementMethodModel": SiteProcurementMethodModel,
    "SiteSearchModelResponse": SiteSearchModelResponse,
    "SiteSearchRequestModel": SiteSearchRequestModel,
    "SiteSearchResponseModel": SiteSearchResponseModel,
    "SiteSharedAddressModel": SiteSharedAddressModel,
    "SiteSharedAddressUpsearchModel": SiteSharedAddressUpsearchModel,
    "SiteSharedContactModel": SiteSharedContactModel,
    "SiteSharedContactModels": SiteSharedContactModels,
    "SiteSharedContactPreferenceModel": SiteSharedContactPreferenceModel,
    "SiteSharedContactUpsearchModel": SiteSharedContactUpsearchModel,
    "SiteSharedEmailAddressModel": SiteSharedEmailAddressModel,
    "SiteSharedEmailAddressUpsearchModel": SiteSharedEmailAddressUpsearchModel,
    "SiteSharedExternalIdModel": SiteSharedExternalIdModel,
    "SiteSharedExternalIdUpsearchModel": SiteSharedExternalIdUpsearchModel,
    "SiteSharedGlobalIdModel": SiteSharedGlobalIdModel,
    "SiteSharedGlobalIdUpsearchModel": SiteSharedGlobalIdUpsearchModel,
    "SiteSharedPhoneModel": SiteSharedPhoneModel,
    "SiteSharedPhoneUpsearchModel": SiteSharedPhoneUpsearchModel,
    "SiteSharedWebAddressModel": SiteSharedWebAddressModel,
    "SiteSharedWebAddressUpsearchModel": SiteSharedWebAddressUpsearchModel,
    "SiteUpsearchModel": SiteUpsearchModel,
    "SubmitClaimResultModel": SubmitClaimResultModel,
    "SubmitClaimResultModelResponse": SubmitClaimResultModelResponse,
    "SurveyFullSurveySessionValuesModel": SurveyFullSurveySessionValuesModel,
    "SurveyIdListRequestModel": SurveyIdListRequestModel,
    "SurveyQuestionCategoryModel": SurveyQuestionCategoryModel,
    "SurveyResponseModel": SurveyResponseModel,
    "SurveySaveQuestionResultModelResponse": SurveySaveQuestionResultModelResponse,
    "SurveySaveQuestionResultRequestModel": SurveySaveQuestionResultRequestModel,
    "SurveySaveQuestionResultResponseModel": SurveySaveQuestionResultResponseModel,
    "SurveySessionPostRequest": SurveySessionPostRequest,
    "SurveySessionValueModel": SurveySessionValueModel,
    "SurveySessionValuePostRequest": SurveySessionValuePostRequest,
    "SurveySessionValueReadModel": SurveySessionValueReadModel,
    "SurveySessionValueReadModels": SurveySessionValueReadModels,
    "SurveyStartSessionModelResponse": SurveyStartSessionModelResponse,
    "SurveyStartSessionRequestModel": SurveyStartSessionRequestModel,
    "SurveyStartSessionResponseModel": SurveyStartSessionResponseModel,
    "TempGetNumberOfApplicationsDefaultResponse": TempGetNumberOfApplicationsDefaultResponse,
    "TempGetNumberOfApplicationsDefaultResponseData": TempGetNumberOfApplicationsDefaultResponseData,
    "TempJanssenGeCheckDefaultResponse": TempJanssenGeCheckDefaultResponse,
    "UnsubscribeBySourceNameRequestModel": UnsubscribeBySourceNameRequestModel,
    "UnsubscribeRequestModel": UnsubscribeRequestModel,
    "UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel": UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    "UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel": UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    "UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel": UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    "UpsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel": UpsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel,
    "UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel": UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    "UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel": UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel,
    "UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel": UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    "UpsearchModelPayorPayorUpsearchModel": UpsearchModelPayorPayorUpsearchModel,
    "UpsearchModelPharmacyPharmacyUpsearchModel": UpsearchModelPharmacyPharmacyUpsearchModel,
    "UpsearchModelPrescriberPrescriberUpsearchModel": UpsearchModelPrescriberPrescriberUpsearchModel,
    "UpsearchModelSiteSiteUpsearchModel": UpsearchModelSiteSiteUpsearchModel,
    "UserRequestModel": UserRequestModel,
    "WorkflowModel": WorkflowModel,
});
//# sourceMappingURL=models.js.map